var _defs, _g, _path, _g2, _path2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath2304(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "340.44pt",
    height: "84.317pt",
    viewBox: "0 0 340.44 84.317",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.6875-5.375h0.625l1.7969 5.375h-0.65625l-0.51562-1.625h-1.8438l-0.48438 1.625zm1.2656-2.2031h1.4844l-0.45312-1.4844c-0.14844-0.45703-0.25-0.83203-0.3125-1.125-0.054687 0.35547-0.13281 0.69922-0.23438 1.0312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7344 0-1.7031-5.375h0.625l1.1562 3.9062c0.082031 0.30469 0.15625 0.59375 0.21875 0.875 0.070312-0.28906 0.14844-0.58203 0.23438-0.875l1.1875-3.9062h0.59375l-1.7188 5.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0v-0.75h0.625v0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.46875 0v-5.375h1.5156c0.375 0 0.66016 0.039062 0.85938 0.10938 0.25 0.085937 0.46875 0.24219 0.65625 0.46875 0.1875 0.23047 0.33203 0.51562 0.4375 0.85938 0.11328 0.34375 0.17188 0.75 0.17188 1.2188 0 0.61719-0.09375 1.1367-0.28125 1.5625-0.17969 0.41797-0.40625 0.71484-0.6875 0.89062-0.27344 0.17969-0.63672 0.26562-1.0938 0.26562zm0.57812-0.64062h0.9375c0.375 0 0.66016-0.054687 0.85938-0.17188 0.19531-0.125 0.34766-0.32031 0.45312-0.59375 0.13281-0.36328 0.20312-0.80078 0.20312-1.3125 0-0.53906-0.074219-0.96875-0.21875-1.2812-0.14844-0.3125-0.33984-0.51953-0.57812-0.625-0.15625-0.070312-0.40234-0.10938-0.73438-0.10938h-0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 0v-5.375h0.57812v5.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.46875 0v-5.375h1.6719c0.38281 0 0.67188 0.039062 0.85938 0.10938 0.25 0.09375 0.44531 0.26562 0.59375 0.51562 0.15625 0.25 0.23438 0.55859 0.23438 0.92188 0 0.49219-0.125 0.88672-0.375 1.1875-0.24219 0.30469-0.66406 0.45312-1.2656 0.45312h-1.125v2.1875zm0.59375-2.8125h1.1406c0.35156 0 0.61328-0.078125 0.78125-0.23438 0.16406-0.16406 0.25-0.41406 0.25-0.75 0-0.20703-0.042969-0.38281-0.125-0.53125-0.085937-0.15625-0.18359-0.25781-0.29688-0.3125-0.11719-0.0625-0.32422-0.09375-0.625-0.09375h-1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3438-5.375h0.59375v3.1094c0 0.52344-0.054688 0.94922-0.15625 1.2812-0.09375 0.33594-0.27734 0.60156-0.54688 0.79688-0.27344 0.1875-0.60938 0.28125-1.0156 0.28125-0.58594 0-1.0234-0.17188-1.3125-0.51562-0.29297-0.35156-0.4375-0.96875-0.4375-1.8438v-3.1094h0.59375v3.1094c0 0.48047 0.035156 0.82812 0.10938 1.0469 0.070313 0.21875 0.19141 0.38672 0.35938 0.5 0.17578 0.11719 0.39062 0.17188 0.64062 0.17188 0.41406 0 0.71094-0.11328 0.89062-0.34375 0.1875-0.23828 0.28125-0.69531 0.28125-1.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6094 0v-4.7344h-1.4531v-0.64062h3.4844v0.64062h-1.4531v4.7344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5938-1.875 0.59375 0.17188c-0.13672 0.60547-0.36719 1.0586-0.6875 1.3594-0.32422 0.29297-0.71484 0.4375-1.1719 0.4375-0.40625 0-0.75781-0.097656-1.0469-0.29688-0.29297-0.19531-0.53125-0.51562-0.71875-0.95312-0.17969-0.44531-0.26562-0.96875-0.26562-1.5625s0.085937-1.0938 0.26562-1.5c0.1875-0.40625 0.4375-0.71094 0.75-0.92188 0.32031-0.20703 0.67578-0.3125 1.0625-0.3125 0.42578 0 0.78906 0.13281 1.0938 0.39062 0.30078 0.26172 0.51562 0.65234 0.64062 1.1719l-0.57812 0.15625c-0.1875-0.75-0.57812-1.125-1.1719-1.125-0.29297 0-0.54688 0.078125-0.76562 0.23438-0.21094 0.14844-0.38281 0.38281-0.51562 0.70312-0.125 0.3125-0.1875 0.71484-0.1875 1.2031 0 0.73047 0.12891 1.2812 0.39062 1.6562 0.25781 0.36719 0.60156 0.54688 1.0312 0.54688 0.32031 0 0.59766-0.10938 0.82812-0.32812 0.22656-0.22656 0.37891-0.57031 0.45312-1.0312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.3125-2.6094c0-0.91406 0.19531-1.6172 0.59375-2.1094 0.40625-0.5 0.91016-0.75 1.5156-0.75 0.38281 0 0.73828 0.10938 1.0625 0.32812 0.32031 0.21875 0.57031 0.54297 0.75 0.96875 0.1875 0.41797 0.28125 0.91406 0.28125 1.4844 0 0.80469-0.17969 1.4531-0.53125 1.9531-0.39844 0.55469-0.91797 0.82812-1.5625 0.82812-0.65625 0-1.1836-0.28516-1.5781-0.85938-0.35547-0.50781-0.53125-1.125-0.53125-1.8438zm0.59375 0c0 0.66797 0.14453 1.1836 0.4375 1.5469 0.28906 0.36719 0.64453 0.54688 1.0625 0.54688 0.42578 0 0.78516-0.17969 1.0781-0.54688 0.28906-0.375 0.4375-0.92188 0.4375-1.6406 0-0.45703-0.074219-0.86719-0.21875-1.2344-0.11719-0.26953-0.29297-0.48828-0.53125-0.65625-0.23047-0.17578-0.48047-0.26562-0.75-0.26562-0.4375 0-0.80469 0.1875-1.0938 0.5625-0.28125 0.36719-0.42188 0.92969-0.42188 1.6875zm1-3.125 0.39062-1.0156h0.70312l-0.65625 1.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.45312 0v-5.375h0.60938l2.3125 4.2188v-4.2188h0.54688v5.375h-0.59375l-2.3125-4.2188v4.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.48438 0v-5.375h3.1875v0.64062h-2.6094v1.6406h2.4375v0.625h-2.4375v1.8281h2.7031v0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.03125 0 1.7031-2.7969-1.5-2.5781h0.6875l0.79688 1.3906c0.16406 0.28125 0.28516 0.5 0.35938 0.65625 0.09375-0.19531 0.20703-0.39844 0.34375-0.60938l0.89062-1.4375h0.625l-1.5312 2.5312 1.6562 2.8438h-0.71875l-1.1094-1.9219c-0.0625-0.10156-0.125-0.22266-0.1875-0.35938-0.10547 0.19922-0.17969 0.33594-0.21875 0.40625l-1.0938 1.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.46875 0v-5.375h1.9531c0.40625 0 0.70703 0.054688 0.90625 0.15625 0.19531 0.10547 0.35156 0.27344 0.46875 0.5 0.125 0.23047 0.1875 0.5 0.1875 0.8125 0 0.40625-0.10547 0.73438-0.3125 0.98438-0.21094 0.25-0.51562 0.41406-0.92188 0.48438 0.16406 0.09375 0.28906 0.19531 0.375 0.29688 0.17578 0.19922 0.32812 0.42188 0.45312 0.67188l0.78125 1.4688h-0.73438l-0.59375-1.1094c-0.21875-0.4375-0.39062-0.73438-0.51562-0.89062-0.11719-0.15625-0.23047-0.25781-0.34375-0.3125-0.10547-0.050781-0.25-0.078125-0.4375-0.078125h-0.67188v2.3906zm0.59375-3h1.25c0.26953 0 0.47266-0.03125 0.60938-0.09375 0.14453-0.070312 0.25781-0.17578 0.34375-0.3125 0.082031-0.14453 0.125-0.3125 0.125-0.5 0-0.26953-0.078125-0.48438-0.23438-0.64062s-0.39062-0.23438-0.70312-0.23438h-1.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.3125-2.6094c0-0.91406 0.19531-1.6172 0.59375-2.1094 0.40625-0.5 0.91016-0.75 1.5156-0.75 0.38281 0 0.73828 0.10938 1.0625 0.32812 0.32031 0.21875 0.57031 0.54297 0.75 0.96875 0.1875 0.41797 0.28125 0.91406 0.28125 1.4844 0 0.80469-0.17969 1.4531-0.53125 1.9531-0.39844 0.55469-0.91797 0.82812-1.5625 0.82812-0.65625 0-1.1836-0.28516-1.5781-0.85938-0.35547-0.50781-0.53125-1.125-0.53125-1.8438zm0.59375 0c0 0.66797 0.14453 1.1836 0.4375 1.5469 0.28906 0.36719 0.64453 0.54688 1.0625 0.54688 0.42578 0 0.78516-0.17969 1.0781-0.54688 0.28906-0.375 0.4375-0.92188 0.4375-1.6406 0-0.45703-0.074219-0.86719-0.21875-1.2344-0.11719-0.26953-0.29297-0.48828-0.53125-0.65625-0.23047-0.17578-0.48047-0.26562-0.75-0.26562-0.4375 0-0.80469 0.1875-1.0938 0.5625-0.28125 0.36719-0.42188 0.92969-0.42188 1.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.45312 0v-5.375h0.60938l2.3125 4.2188v-4.2188h0.54688v5.375h-0.59375l-2.3125-4.2188v4.2188zm0.76562-5.75c0-0.25781 0.0625-0.46094 0.1875-0.60938 0.11328-0.14453 0.25391-0.21875 0.42188-0.21875 0.13281 0 0.30469 0.070313 0.51562 0.20312 0.11328 0.074219 0.20703 0.10938 0.28125 0.10938 0.0625 0 0.10938-0.019531 0.14062-0.0625 0.039063-0.050781 0.066406-0.14062 0.078125-0.26562h0.39062c-0.011719 0.28125-0.074219 0.49609-0.1875 0.64062-0.10547 0.13672-0.24219 0.20312-0.40625 0.20312-0.125 0-0.29297-0.070312-0.5-0.21875-0.125-0.082031-0.21875-0.125-0.28125-0.125-0.074219 0-0.13281 0.03125-0.17188 0.09375-0.042969 0.054688-0.0625 0.13672-0.0625 0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.51562 0v-5.375h2.9688v0.64062h-2.3906v1.6562h2.0781v0.64062h-2.0781v2.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.1875-1.6094v-0.67188h1.6719v0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2812 0h-0.54688v-4.2031c-0.125 0.14844-0.29297 0.29688-0.5 0.45312-0.21094 0.15625-0.40234 0.27344-0.57812 0.34375v-0.64062c0.30078-0.16406 0.56641-0.375 0.79688-0.625 0.22656-0.25 0.39062-0.48828 0.48438-0.71875h0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-1.4062 0.5625-0.0625c0.039062 0.34375 0.14062 0.60156 0.29688 0.76562 0.15625 0.16797 0.33594 0.25 0.54688 0.25 0.25 0 0.46875-0.11328 0.65625-0.34375 0.1875-0.23828 0.28125-0.5625 0.28125-0.96875 0-0.38281-0.09375-0.67969-0.28125-0.89062-0.17969-0.21875-0.40234-0.32812-0.67188-0.32812-0.15625 0-0.30859 0.046875-0.45312 0.14062-0.14844 0.09375-0.26172 0.22656-0.34375 0.39062l-0.5-0.078125 0.42188-2.7656h2.1875v0.625h-1.75l-0.23438 1.4531c0.25781-0.22656 0.53516-0.34375 0.82812-0.34375 0.36328 0 0.67969 0.15625 0.95312 0.46875 0.28125 0.3125 0.42188 0.74219 0.42188 1.2812 0 0.52344-0.14062 0.96875-0.42188 1.3438-0.27344 0.375-0.63672 0.5625-1.0938 0.5625-0.375 0-0.69922-0.12891-0.96875-0.39062-0.26172-0.26953-0.40625-0.64062-0.4375-1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-1.4219 0.54688-0.078125c0.10156 0.69922 0.38281 1.0469 0.84375 1.0469 0.25 0 0.46094-0.10156 0.64062-0.3125 0.1875-0.20703 0.28125-0.47656 0.28125-0.8125 0-0.3125-0.085938-0.5625-0.25-0.75-0.16797-0.1875-0.37109-0.28125-0.60938-0.28125-0.10547 0-0.23438 0.023437-0.39062 0.0625l0.0625-0.57812 0.09375 0.015625c0.25781 0 0.47266-0.082031 0.64062-0.25 0.16406-0.16406 0.25-0.38281 0.25-0.65625 0-0.25-0.074219-0.44531-0.21875-0.59375-0.13672-0.15625-0.30469-0.23438-0.5-0.23438-0.21094 0-0.38672 0.078125-0.53125 0.23438-0.13672 0.15625-0.22656 0.40234-0.26562 0.73438l-0.54688-0.125c0.070313-0.45703 0.22656-0.80078 0.46875-1.0312 0.23828-0.23828 0.53125-0.35938 0.875-0.35938 0.35156 0 0.65625 0.13672 0.90625 0.40625 0.25 0.26172 0.375 0.58984 0.375 0.98438 0 0.24219-0.058594 0.46094-0.17188 0.65625-0.10547 0.1875-0.25 0.33594-0.4375 0.4375 0.17578 0.054688 0.32031 0.13672 0.4375 0.25 0.11328 0.10547 0.20312 0.25 0.26562 0.4375 0.070313 0.1875 0.10938 0.40234 0.10938 0.64062 0 0.49219-0.14844 0.89062-0.4375 1.2031-0.28125 0.3125-0.625 0.46875-1.0312 0.46875-0.375 0-0.69922-0.13281-0.96875-0.40625-0.26172-0.26953-0.40625-0.64062-0.4375-1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844 0v-1.2812h-1.9219v-0.60938l2.0156-3.4844h0.4375v3.4844h0.59375v0.60938h-0.59375v1.2812zm0-1.8906v-2.4219l-1.3906 2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-2.6406c0-0.90625 0.11719-1.5859 0.35938-2.0469 0.23828-0.46875 0.59766-0.70312 1.0781-0.70312 0.41406 0 0.74219 0.1875 0.98438 0.5625 0.28906 0.46094 0.4375 1.1875 0.4375 2.1875 0 0.89844-0.12109 1.5781-0.35938 2.0469-0.24219 0.46094-0.60156 0.6875-1.0781 0.6875-0.41797 0-0.76172-0.20312-1.0312-0.60938-0.26172-0.41406-0.39062-1.125-0.39062-2.125zm0.54688 0c0 0.86719 0.082031 1.4492 0.25 1.75 0.16406 0.29297 0.37891 0.4375 0.64062 0.4375 0.25 0 0.45703-0.14453 0.625-0.4375 0.16406-0.30078 0.25-0.88281 0.25-1.75 0-0.875-0.085938-1.457-0.25-1.75-0.16797-0.30078-0.38672-0.45312-0.65625-0.45312-0.24219 0-0.44531 0.15234-0.60938 0.45312-0.16797 0.30469-0.25 0.88672-0.25 1.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0469-4.0469-0.53125 0.046875c-0.054687-0.28125-0.13281-0.47656-0.23438-0.59375-0.14844-0.16406-0.32031-0.25-0.51562-0.25-0.3125 0-0.57031 0.19531-0.76562 0.57812-0.15625 0.34375-0.23438 0.84375-0.23438 1.5 0.11328-0.23828 0.26562-0.41406 0.45312-0.53125 0.19531-0.125 0.39844-0.1875 0.60938-0.1875 0.34375 0 0.64453 0.16406 0.90625 0.48438 0.25781 0.3125 0.39062 0.73438 0.39062 1.2656 0 0.35547-0.070312 0.67969-0.20312 0.96875-0.125 0.29297-0.29297 0.51172-0.5 0.65625-0.19922 0.13281-0.42188 0.20312-0.67188 0.20312-0.44922 0-0.82031-0.19531-1.1094-0.59375-0.28125-0.40625-0.42188-1.0781-0.42188-2.0156 0-1.0312 0.14453-1.7656 0.4375-2.2031 0.30078-0.44531 0.67969-0.67188 1.1406-0.67188 0.33203 0 0.61328 0.11719 0.84375 0.34375 0.22656 0.23047 0.36328 0.5625 0.40625 1zm-2.2031 2.3125c0 0.38672 0.085938 0.69922 0.26562 0.9375 0.1875 0.23047 0.39844 0.34375 0.64062 0.34375 0.21875 0 0.41016-0.10938 0.57812-0.32812 0.16406-0.21875 0.25-0.52344 0.25-0.92188 0-0.375-0.085937-0.66406-0.25-0.875-0.16797-0.21875-0.37109-0.32812-0.60938-0.32812-0.24219 0-0.44922 0.10547-0.625 0.3125-0.16797 0.21094-0.25 0.49609-0.25 0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125-1.7188 0.54688-0.0625c0.03125 0.29297 0.097656 0.52344 0.20312 0.6875 0.10156 0.16797 0.25 0.30469 0.4375 0.40625 0.19531 0.09375 0.41406 0.14062 0.65625 0.14062 0.34375 0 0.60938-0.082031 0.79688-0.25 0.19531-0.17578 0.29688-0.39844 0.29688-0.67188 0-0.15625-0.039062-0.28906-0.10938-0.40625-0.0625-0.11328-0.16797-0.20703-0.3125-0.28125-0.13672-0.082031-0.4375-0.19141-0.90625-0.32812-0.41797-0.125-0.71484-0.25-0.89062-0.375-0.17969-0.125-0.3125-0.28125-0.40625-0.46875-0.09375-0.19531-0.14062-0.41406-0.14062-0.65625 0-0.42578 0.14062-0.77344 0.42188-1.0469 0.28125-0.28125 0.65625-0.42188 1.125-0.42188 0.33203 0 0.61719 0.0625 0.85938 0.1875 0.25 0.125 0.44141 0.3125 0.57812 0.5625 0.13281 0.24219 0.20703 0.52344 0.21875 0.84375l-0.5625 0.046875c-0.03125-0.34375-0.13672-0.59766-0.3125-0.76562-0.17969-0.16406-0.43359-0.25-0.76562-0.25-0.32422 0-0.57422 0.074219-0.75 0.21875-0.17969 0.14844-0.26562 0.33594-0.26562 0.5625 0 0.21875 0.066406 0.39062 0.20312 0.51562 0.125 0.11719 0.40625 0.23438 0.84375 0.35938s0.74219 0.23047 0.92188 0.3125c0.26953 0.13672 0.47266 0.32031 0.60938 0.54688 0.13281 0.21875 0.20312 0.48438 0.20312 0.79688 0 0.30469-0.074219 0.58594-0.21875 0.84375-0.14844 0.25-0.34375 0.44531-0.59375 0.57812-0.24219 0.125-0.53906 0.1875-0.89062 0.1875-0.54297 0-0.97656-0.16016-1.2969-0.48438-0.32422-0.33203-0.49219-0.77344-0.5-1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.46875 0v-5.375h0.59375v2.2031h2.2812v-2.2031h0.57812v5.375h-0.57812v-2.5312h-2.2812v2.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.4375 0v-5.375h0.57812v4.7344h2.1719v0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5469-2.1094v-0.625h1.8594v1.9844c-0.28125 0.28125-0.57812 0.49609-0.89062 0.64062-0.30469 0.13281-0.61719 0.20312-0.9375 0.20312-0.42969 0-0.80859-0.10156-1.1406-0.3125-0.33594-0.21875-0.60156-0.53516-0.79688-0.95312-0.19922-0.41406-0.29688-0.91016-0.29688-1.4844 0-0.58203 0.097656-1.0938 0.29688-1.5312 0.19531-0.4375 0.45312-0.75391 0.76562-0.95312 0.32031-0.20703 0.70312-0.3125 1.1406-0.3125 0.32031 0 0.60156 0.0625 0.84375 0.1875 0.23828 0.11719 0.4375 0.28125 0.59375 0.5s0.27344 0.51562 0.35938 0.89062l-0.53125 0.1875c-0.0625-0.30078-0.15234-0.52344-0.26562-0.67188-0.10547-0.15625-0.24609-0.27344-0.42188-0.35938-0.17969-0.09375-0.375-0.14062-0.59375-0.14062-0.32422 0-0.60156 0.078125-0.82812 0.23438-0.23047 0.15625-0.41797 0.40234-0.5625 0.73438-0.13672 0.32422-0.20312 0.71875-0.20312 1.1875 0 0.71875 0.14844 1.2617 0.45312 1.625 0.30078 0.35547 0.69141 0.53125 1.1719 0.53125 0.22656 0 0.46094-0.050781 0.70312-0.15625 0.23828-0.11328 0.42969-0.25 0.57812-0.40625v-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.125 0v-0.65625l2.2656-3.4375c0.15625-0.23828 0.30469-0.45312 0.45312-0.64062h-2.4531v-0.64062h3.1406v0.64062l-2.4688 3.7188-0.26562 0.375h2.8125v0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.45312 0v-5.375h0.875l1.0469 3.8125 0.20312 0.79688c0.050781-0.19531 0.12891-0.48828 0.23438-0.875l1.0625-3.7344h0.78125v5.375h-0.5625v-4.5l-1.2812 4.5h-0.51562l-1.2812-4.5781v4.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.45312 0v-5.375h1.6562c0.33203 0 0.59375 0.054688 0.78125 0.15625 0.19531 0.10547 0.35938 0.27344 0.48438 0.5 0.125 0.21875 0.1875 0.46094 0.1875 0.71875 0 0.25-0.054688 0.47656-0.15625 0.67188-0.10547 0.19922-0.25781 0.35547-0.45312 0.46875 0.25781 0.09375 0.46094 0.25781 0.60938 0.48438 0.14453 0.21875 0.21875 0.49219 0.21875 0.8125 0 0.33594-0.070312 0.625-0.20312 0.875-0.13672 0.24219-0.3125 0.41797-0.53125 0.53125-0.21875 0.10547-0.52734 0.15625-0.92188 0.15625zm0.57812-3.1094h0.95312c0.25 0 0.42578-0.019531 0.53125-0.0625 0.15625-0.039063 0.26953-0.125 0.34375-0.25 0.082031-0.125 0.125-0.28906 0.125-0.5 0-0.1875-0.039063-0.34375-0.10938-0.46875-0.074219-0.13281-0.17188-0.22266-0.29688-0.26562-0.11719-0.050781-0.33594-0.078125-0.65625-0.078125h-0.89062zm0 2.4688h1.0938c0.25 0 0.42969-0.019531 0.54688-0.0625 0.16406-0.0625 0.28906-0.16406 0.375-0.3125 0.082031-0.14453 0.125-0.32812 0.125-0.54688 0-0.19531-0.042969-0.36328-0.125-0.5-0.085937-0.14453-0.19922-0.25-0.34375-0.3125-0.13672-0.070312-0.35547-0.10938-0.65625-0.10938h-1.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.17188-1.5312 0.51562-0.078125c0.007812 0.40625 0.070312 0.6875 0.1875 0.84375 0.11328 0.14844 0.26953 0.21875 0.46875 0.21875 0.13281 0 0.25391-0.035156 0.35938-0.10938 0.11328-0.070312 0.1875-0.17188 0.21875-0.29688 0.050781-0.15625 0.078125-0.39453 0.078125-0.71875v-3.7031h0.57812v3.6719c0 0.65625-0.10938 1.1211-0.32812 1.3906-0.21094 0.27344-0.51172 0.40625-0.90625 0.40625-0.38672 0-0.67188-0.125-0.85938-0.375-0.21094-0.26953-0.3125-0.6875-0.3125-1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625-3.1406v-0.75h0.625v0.75zm0 3.1406v-0.75h0.625v0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0781-2.9062c-0.21875-0.10156-0.38672-0.24219-0.5-0.42188-0.10547-0.1875-0.15625-0.41406-0.15625-0.6875 0-0.40625 0.11719-0.73438 0.35938-0.98438 0.23828-0.25781 0.53906-0.39062 0.90625-0.39062 0.36328 0 0.66406 0.13281 0.90625 0.39062 0.25 0.26172 0.375 0.60156 0.375 1.0156 0 0.26172-0.058594 0.48047-0.17188 0.65625-0.10547 0.17969-0.26562 0.32031-0.48438 0.42188 0.26953 0.10547 0.47266 0.27734 0.60938 0.51562 0.14453 0.23047 0.21875 0.51562 0.21875 0.85938 0 0.48047-0.14062 0.87109-0.42188 1.1719-0.27344 0.30469-0.60938 0.45312-1.0156 0.45312-0.41797 0-0.76562-0.14844-1.0469-0.45312-0.28125-0.30078-0.42188-0.69531-0.42188-1.1875 0-0.36328 0.070313-0.66016 0.21875-0.89062 0.15625-0.22656 0.36328-0.38281 0.625-0.46875zm-0.10938-1.125c0 0.26172 0.066406 0.46875 0.20312 0.625 0.14453 0.15625 0.32031 0.23438 0.53125 0.23438 0.19531 0 0.36328-0.070313 0.5-0.21875 0.13281-0.15625 0.20312-0.35156 0.20312-0.59375 0-0.25781-0.074219-0.46875-0.21875-0.625-0.13672-0.15625-0.30469-0.23438-0.5-0.23438-0.19922 0-0.37109 0.078125-0.51562 0.23438-0.13672 0.15625-0.20312 0.35156-0.20312 0.57812zm-0.17188 2.4844c0 0.32422 0.085937 0.58984 0.26562 0.79688 0.17578 0.19922 0.39062 0.29688 0.64062 0.29688 0.23828 0 0.44531-0.09375 0.625-0.28125 0.17578-0.19531 0.26562-0.46094 0.26562-0.79688 0-0.32031-0.09375-0.58203-0.28125-0.78125-0.17969-0.20703-0.38672-0.3125-0.625-0.3125-0.25 0-0.46484 0.10156-0.64062 0.29688-0.16797 0.19922-0.25 0.46094-0.25 0.78125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.09375 1.2812-5.5469h0.42188l-1.2656 5.5469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.32812-1.2344 0.51562-0.0625c0.082031 0.5625 0.32812 0.84375 0.73438 0.84375 0.17578 0 0.33594-0.0625 0.48438-0.1875 0.15625-0.125 0.28125-0.34375 0.375-0.65625 0.10156-0.3125 0.15625-0.67578 0.15625-1.0938v-0.14062c-0.10547 0.21875-0.25781 0.39844-0.45312 0.53125-0.1875 0.125-0.38281 0.1875-0.57812 0.1875-0.35547 0-0.66406-0.15625-0.92188-0.46875-0.26172-0.32031-0.39062-0.75391-0.39062-1.2969 0-0.5625 0.13281-1.0039 0.40625-1.3281 0.26953-0.32031 0.59766-0.48438 0.98438-0.48438 0.26953 0 0.51953 0.09375 0.75 0.28125 0.23828 0.17969 0.42188 0.44531 0.54688 0.79688 0.13281 0.34375 0.20312 0.85156 0.20312 1.5156 0 0.73047-0.074219 1.3047-0.21875 1.7188-0.13672 0.40625-0.32422 0.70312-0.5625 0.89062-0.23047 0.1875-0.49609 0.28125-0.79688 0.28125-0.33594 0-0.61719-0.11328-0.84375-0.34375-0.21875-0.22656-0.35156-0.55469-0.39062-0.98438zm2.2188-2.375c0-0.38281-0.089844-0.6875-0.26562-0.90625-0.16797-0.21875-0.35938-0.32812-0.57812-0.32812-0.24219 0-0.45312 0.12109-0.64062 0.35938-0.17969 0.23047-0.26562 0.53906-0.26562 0.92188 0 0.35547 0.085937 0.63672 0.26562 0.84375 0.17578 0.21094 0.38281 0.3125 0.625 0.3125 0.23828 0 0.44141-0.10156 0.60938-0.3125 0.16406-0.20703 0.25-0.50391 0.25-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125-4.6719v-0.625h2.8438v0.51562c-0.41797 0.55469-0.78906 1.2734-1.1094 2.1562-0.32422 0.88672-0.51172 1.7617-0.5625 2.625h-0.5625c0.007813-0.44531 0.082031-0.96875 0.21875-1.5625 0.13281-0.60156 0.32031-1.1758 0.5625-1.7188 0.23828-0.53906 0.49219-1.0039 0.76562-1.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0938-0.64062v0.64062h-2.9062c-0.011719-0.25781 0.0625-0.54688 0.21875-0.85938 0.16406-0.32031 0.46875-0.69531 0.90625-1.125 0.5-0.5 0.82812-0.88281 0.98438-1.1562 0.15625-0.28125 0.23438-0.53906 0.23438-0.78125 0-0.26953-0.085938-0.48828-0.25-0.65625-0.15625-0.17578-0.35156-0.26562-0.57812-0.26562-0.25 0-0.46094 0.09375-0.625 0.28125-0.15625 0.1875-0.23438 0.45312-0.23438 0.79688l-0.5625-0.078125c0.039062-0.50781 0.1875-0.89453 0.4375-1.1562 0.25781-0.25781 0.59375-0.39062 1-0.39062 0.44531 0 0.78516 0.15234 1.0156 0.45312 0.23828 0.30469 0.35938 0.64844 0.35938 1.0312 0 0.34375-0.09375 0.67188-0.28125 0.98438-0.17969 0.3125-0.52344 0.73047-1.0312 1.25-0.32422 0.33594-0.53125 0.5625-0.625 0.6875-0.09375 0.11719-0.16797 0.23047-0.21875 0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4375 1.5781c-0.27344-0.41797-0.51562-0.93359-0.73438-1.5469s-0.32812-1.2734-0.32812-1.9844c0-1.1875 0.35156-2.3516 1.0625-3.5h0.39062c-0.28125 0.57422-0.47656 1.0156-0.57812 1.3281-0.09375 0.3125-0.17188 0.66406-0.23438 1.0469-0.0625 0.375-0.09375 0.75781-0.09375 1.1406 0 1.168 0.30078 2.3359 0.90625 3.5156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.60938 1.5781h-0.39062c0.60156-1.1797 0.90625-2.3477 0.90625-3.5156 0-0.38281-0.03125-0.76562-0.09375-1.1406-0.0625-0.38281-0.14844-0.73438-0.25-1.0469-0.09375-0.3125-0.28125-0.75391-0.5625-1.3281h0.39062c0.70703 1.1484 1.0625 2.3125 1.0625 3.5 0 0.6875-0.10547 1.3398-0.3125 1.9531-0.21094 0.61328-0.46094 1.1406-0.75 1.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.29688 0.09375 0.26562-1.5625h-0.5v-0.54688h0.59375l0.21875-1.3281h-0.8125v-0.54688h0.90625l0.26562-1.5625h0.4375l-0.26562 1.5625h0.95312l0.26562-1.5625h0.45312l-0.26562 1.5625h0.53125v0.54688h-0.625l-0.21875 1.3281h0.84375v0.54688h-0.9375l-0.25 1.5625h-0.45312l0.25-1.5625h-0.9375l-0.26562 1.5625zm0.8125-2.1094h0.9375l0.21875-1.3281h-0.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5938-0.59375 0.078125 0.59375c-0.14844 0.03125-0.28125 0.046875-0.40625 0.046875-0.1875 0-0.33984-0.039062-0.45312-0.10938-0.11719-0.070312-0.19531-0.17188-0.23438-0.29688-0.042969-0.13281-0.0625-0.39453-0.0625-0.78125v-2.2344h-0.39062v-0.51562h0.39062v-0.96875l0.54688-0.39062v1.3594h0.53125v0.51562h-0.53125v2.2656c0 0.21875 0.015625 0.35547 0.046875 0.40625 0.039063 0.09375 0.125 0.14062 0.25 0.14062 0.0625 0 0.14062-0.007812 0.23438-0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5781-1.25 0.5625 0.078125c-0.09375 0.41797-0.26562 0.73438-0.51562 0.95312-0.24219 0.21094-0.53906 0.3125-0.89062 0.3125-0.46094 0-0.82812-0.17188-1.1094-0.51562-0.27344-0.34375-0.40625-0.83594-0.40625-1.4844 0-0.67578 0.14062-1.1914 0.42188-1.5469 0.28125-0.35156 0.63281-0.53125 1.0625-0.53125 0.41406 0 0.75781 0.17969 1.0312 0.53125 0.28125 0.34375 0.42188 0.84375 0.42188 1.5v0.17188h-2.3906c0.019531 0.4375 0.11719 0.77344 0.29688 1 0.1875 0.21875 0.41016 0.32812 0.67188 0.32812 0.40625 0 0.6875-0.26562 0.84375-0.79688zm-1.7812-1.0625h1.7812c-0.023437-0.34375-0.09375-0.59766-0.21875-0.76562-0.16797-0.23828-0.38672-0.35938-0.65625-0.35938-0.24219 0-0.44922 0.10547-0.625 0.3125-0.16797 0.19922-0.26172 0.46875-0.28125 0.8125zm0.51562-2.0625 0.39062-1.0156h0.70312l-0.65625 1.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.25 0-1.1719-5.375h0.60938l0.65625 3.5312c0.070312 0.35547 0.13281 0.71875 0.1875 1.0938l0.20312-1 0.84375-3.625h0.70312l0.625 2.7188c0.15625 0.66797 0.26953 1.3047 0.34375 1.9062 0.0625-0.35156 0.13281-0.74219 0.21875-1.1719l0.6875-3.4531h0.59375l-1.2188 5.375h-0.54688l-0.9375-4.0938-0.14062-0.625c-0.042969 0.23047-0.085938 0.4375-0.125 0.625l-0.9375 4.0938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-22-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0v-0.75h0.60938v0.75c0 0.28906-0.042969 0.51953-0.125 0.6875-0.085937 0.16406-0.21094 0.28906-0.375 0.375l-0.15625-0.28125c0.11328-0.0625 0.19531-0.15234 0.25-0.26562 0.0625-0.11719 0.09375-0.28906 0.09375-0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.6562 1.5781h-0.48438c-0.40625-0.52344-0.72656-1.0898-0.95312-1.7031-0.23047-0.61328-0.34375-1.2188-0.34375-1.8125 0-0.6875 0.11719-1.3203 0.35938-1.9062 0.25-0.58203 0.5625-1.1172 0.9375-1.6094h0.48438c-0.4375 0.71094-0.73438 1.3359-0.89062 1.875-0.14844 0.53125-0.21875 1.0742-0.21875 1.625 0 1.1875 0.36719 2.3633 1.1094 3.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.2031-0.35938-0.45312 0.42188c-0.80469-0.65625-1.3359-1.5312-1.5938-2.625v3.0312h-0.57812v-2.875c-0.17969 0.75-0.75781 1.5547-1.7344 2.4062l-0.40625-0.45312c0.875-0.72656 1.4414-1.5391 1.7031-2.4375h-1.2344v-0.54688h1.6875v-1.0781h-0.73438c-0.13672 0.33594-0.30859 0.64844-0.51562 0.9375l-0.57812-0.26562c0.46875-0.50781 0.72656-1.1758 0.78125-2l0.54688 0.17188c-0.011719 0.21094-0.042969 0.41406-0.09375 0.60938h0.59375v-1.2031h0.5625v1.2031h1.3594v0.54688h-1.3594v1.0781h1.7188v0.54688h-1.25c0.26953 1.0859 0.79688 1.9297 1.5781 2.5312zm-4.0781-1.9844-0.5 0.32812c-0.10547-0.39453-0.26562-0.70312-0.48438-0.92188v3.4062h-0.59375v-3.1562c-0.11719 0.34375-0.41406 0.78906-0.89062 1.3281l-0.45312-0.375c0.71875-0.75781 1.1641-1.6016 1.3438-2.5312h-1.0156v-0.57812h1.0156v-1.4219h0.59375v1.4219h0.8125v0.57812h-0.8125v0.73438l0.0625-0.046875c0.26953 0.15625 0.57812 0.57031 0.92188 1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3438-5.4531c0.39453 0.51172 0.70703 1.0742 0.9375 1.6875 0.23828 0.61719 0.35938 1.2266 0.35938 1.8281 0 0.67969-0.125 1.3086-0.375 1.8906-0.24219 0.58203-0.54688 1.125-0.92188 1.625h-0.48438c0.4375-0.71875 0.72656-1.3438 0.875-1.875 0.14453-0.53906 0.21875-1.0859 0.21875-1.6406 0-1.1758-0.36719-2.3477-1.0938-3.5156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.3594-4.9844-0.53125 0.21875c-0.085937-0.41406-0.20312-0.75-0.35938-1l0.5625-0.21875c0.13281 0.27344 0.24219 0.60547 0.32812 1zm-2.5469-0.21875-0.23438 0.6875c-0.65625-0.38281-1.418-0.61719-2.2812-0.70312l0.23438-0.70312c0.96875 0.19922 1.7266 0.4375 2.2812 0.71875zm1.7031 0.51562-0.51562 0.21875c-0.09375-0.40625-0.21484-0.73828-0.35938-1l0.54688-0.21875c0.13281 0.27344 0.24219 0.60547 0.32812 1zm1.2344 0.9375c-0.6875 1.1055-1.4648 1.9766-2.3281 2.6094-0.86719 0.625-1.9062 1.1055-3.125 1.4375l-0.35938-0.70312c1.2812-0.28906 2.3438-0.74219 3.1875-1.3594 0.84375-0.625 1.5195-1.4375 2.0312-2.4375zm-3.6406 0.4375-0.26562 0.70312c-0.57422-0.39453-1.3242-0.64453-2.25-0.75l0.23438-0.6875c0.92578 0.17969 1.6875 0.42188 2.2812 0.73438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.9219-4.1875-0.95312 2.125-0.57812-0.25 0.625-1.3906-1.2656 0.23438 0.65625 2.9688-0.60938 0.14062-0.67188-2.9844-1.4688 0.26562-0.125-0.60938 1.4688-0.26562-0.23438-1.0781 0.625-0.10938 0.21875 1.0625 1.9531-0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.2656-6.2812c0.21875 0 0.40625 0.085938 0.5625 0.25 0.16406 0.15625 0.25 0.33984 0.25 0.54688 0 0.21875-0.085937 0.40625-0.25 0.5625-0.15625 0.15625-0.34375 0.23438-0.5625 0.23438-0.21094 0-0.39844-0.078125-0.5625-0.23438-0.15625-0.15625-0.23438-0.34375-0.23438-0.5625 0-0.20703 0.078125-0.39062 0.23438-0.54688 0.16406-0.16406 0.35156-0.25 0.5625-0.25zm0 1.0938c0.09375 0 0.16406-0.023438 0.21875-0.078125 0.0625-0.050781 0.09375-0.125 0.09375-0.21875s-0.03125-0.16406-0.09375-0.21875c-0.054687-0.0625-0.125-0.09375-0.21875-0.09375s-0.16797 0.03125-0.21875 0.09375c-0.054687 0.054687-0.078125 0.125-0.078125 0.21875s0.023438 0.16797 0.078125 0.21875c0.050781 0.054687 0.125 0.078125 0.21875 0.078125zm-3.2656-0.53125c-0.14844 1.125-0.40234 2.2344-0.76562 3.3281-0.36719 1.0938-0.78906 1.9688-1.2656 2.625l-0.60938-0.40625c0.51953-0.73828 0.95312-1.6172 1.2969-2.6406 0.35156-1.0195 0.57031-2.0625 0.65625-3.125zm3.6406 5.5625-0.71875 0.1875c-0.074219-0.78906-0.28906-1.707-0.64062-2.75-0.34375-1.0391-0.75781-2.0039-1.2344-2.8906l0.625-0.29688c1.0312 2.1562 1.6875 4.0742 1.9688 5.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-23-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3438-4.5625-0.40625 0.59375c-0.60547-0.50781-1.3203-0.86719-2.1406-1.0781l0.42188-0.60938c0.86328 0.3125 1.5703 0.67969 2.125 1.0938zm3.375 0.76562c-0.86719 1.2734-1.7188 2.1875-2.5625 2.75s-1.8047 0.99609-2.875 1.2969l-0.42188-0.67188c1.332-0.28906 2.3984-0.75 3.2031-1.375 0.8125-0.63281 1.5195-1.4609 2.125-2.4844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.67188-3.2344c0 0.75 0.59375 1.3906 1.5781 1.3906 1.0312 0 1.5938-0.6875 1.5938-1.3906 0-0.57812-0.40625-1.1719-1.2656-1.3281 0.078125-0.14062 0.1875-0.21875 0.1875-0.29688 0-0.10938-0.28125-0.3125-0.45312-0.3125-0.0625 0-0.078125 0.015625-0.078125 0.0625 0 0.03125 0.015625 0.0625 0.0625 0.125 0.03125 0.0625 0.046875 0.10938 0.046875 0.15625 0 0.125-0.10938 0.20312-0.25 0.23438-0.96875 0.14062-1.4219 0.75-1.4219 1.3594zm1.5781-1.0469c0.78125 0 1.1562 0.53125 1.1562 1.0781 0 0.53125-0.375 1.0625-1.1562 1.0625-0.75 0-1.125-0.53125-1.125-1.0625 0-0.54688 0.375-1.0781 1.125-1.0781zm3.0312 4.5781c0 0.25 0.046875 0.34375 0.125 0.34375 0.046875 0 0.10938-0.046875 0.17188-0.125 0.125-0.32812 0.17188-0.625 0.1875-1.1094v-2.1875h1.2969c0.17188 0 0.25-0.078125 0.25-0.1875 0-0.23438-0.3125-0.23438-0.45312-0.23438-0.48438 0-0.35938 0.14062-0.70312 0.20312h-0.375v-2.7344c0-0.10938 0.015625-0.1875 0.015625-0.25s-0.03125-0.125-0.1875-0.1875c-0.25-0.0625-0.54688-0.14062-0.875-0.20312-0.21875 0.015625-0.3125 0.046875-0.3125 0.09375 0 0.03125 0.0625 0.078125 0.14062 0.09375 0.3125 0.15625 0.71875 0.32812 0.71875 0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.0156-3.4219c-0.046875-0.65625-0.45312-1.1562-1.3594-1.3594 0.0625-0.09375 0.15625-0.15625 0.15625-0.21875s-0.26562-0.28125-0.48438-0.28125c-0.046875 0-0.078125 0.03125-0.078125 0.046875 0 0.03125 0.03125 0.078125 0.078125 0.125 0.03125 0.046875 0.0625 0.09375 0.0625 0.14062 0 0.125-0.14062 0.17188-0.28125 0.20312-0.95312 0.125-1.4219 0.76562-1.4219 1.3906 0 0.75 0.625 1.4531 1.7344 1.4531 0.98438 0 1.5156-0.54688 1.5938-1.2656zm-1.5938-1.0469c0.76562 0 1.1719 0.5625 1.1719 1.125s-0.40625 1.125-1.1719 1.125c-0.84375 0-1.2656-0.5625-1.2656-1.125s0.42188-1.125 1.2656-1.125zm3.2031 4.7969c0 0.23438 0.046875 0.3125 0.10938 0.3125 0.046875 0 0.09375-0.046875 0.14062-0.125 0.14062-0.29688 0.1875-0.48438 0.1875-1.8594v-4.4219c0-0.078125 0.03125-0.14062 0.03125-0.20312s-0.03125-0.10938-0.14062-0.15625c-0.17188-0.0625-0.4375-0.17188-0.90625-0.25-0.17188 0.015625-0.25 0.0625-0.25 0.10938 0 0.03125 0.0625 0.078125 0.15625 0.10938 0.4375 0.1875 0.65625 0.375 0.67188 0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.625-2.4531c-1.0312 0.5-2.4688 0.76562-3.625 0.85938-0.20312 0-0.20312-0.015625-0.20312-0.15625v-1.4062c0.48438 0 1.6719-0.03125 2.1719-0.0625 0.125 0 0.20312-0.078125 0.20312-0.15625 0-0.09375-0.10938-0.1875-0.40625-0.1875h-0.015625c-0.625 0-0.45312 0.15625-0.90625 0.1875-0.3125 0-0.84375 0.03125-1.0469 0.03125v-1.3906c0-0.125 0.046875-0.09375 0.125-0.14062 0.71875-0.03125 1.7812-0.078125 2.1094-0.078125 0.15625 0 0.26562-0.09375 0.26562-0.1875s-0.09375-0.21875-0.40625-0.21875c-0.59375 0-0.40625 0.17188-0.875 0.21875-0.39062 0.046875-0.71875 0.0625-1.0156 0.0625h-0.25c-0.23438-0.078125-0.54688-0.15625-0.9375-0.15625-0.15625 0.03125-0.21875 0.078125-0.21875 0.10938 0 0.046875 0.0625 0.078125 0.17188 0.09375 0.34375 0.125 0.54688 0.20312 0.54688 0.42188v2.8906c0 0.17188 0.09375 0.54688 0.45312 0.54688 0.17188 0 2.0781-0.28125 3.8594-1.1094v2.6094c0 0.23438 0.046875 0.3125 0.10938 0.3125 0.046875 0 0.09375-0.046875 0.14062-0.125 0.14062-0.29688 0.1875-0.48438 0.1875-1.8594v-4.4219c0-0.078125 0.03125-0.14062 0.03125-0.20312s-0.03125-0.10938-0.14062-0.15625c-0.17188-0.0625-0.4375-0.17188-0.90625-0.25-0.17188 0.015625-0.25 0.0625-0.25 0.10938 0 0.03125 0.0625 0.078125 0.15625 0.10938 0.4375 0.1875 0.65625 0.375 0.67188 0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4375-4.6562c0.65625 0 0.96875 0.45312 0.96875 0.89062 0 0.42188-0.3125 0.85938-0.96875 0.85938-0.64062 0-0.96875-0.4375-0.96875-0.85938 0-0.4375 0.32812-0.89062 0.96875-0.89062zm2.125 0.57812c-0.29688 0.03125-0.51562 0.046875-0.79688 0.03125-0.078125-0.40625-0.42188-0.75-1.0469-0.89062 0.015625-0.078125 0.09375-0.14062 0.09375-0.21875 0-0.10938-0.25-0.21875-0.40625-0.21875-0.046875 0-0.078125 0.015625-0.078125 0.03125 0 0.03125 0.03125 0.0625 0.078125 0.10938 0.015625 0.046875 0.03125 0.09375 0.03125 0.125 0 0.09375-0.10938 0.15625-0.20312 0.15625-0.8125 0.125-1.1875 0.64062-1.1875 1.1406 0 0.625 0.51562 1.2031 1.4219 1.2031 1.0938 0 1.375-0.9375 1.3438-1.1406 0.078125 0.03125 0.125 0.046875 0.17188 0.046875 0.09375 0 0.10938-0.09375 0.32812-0.10938l0.25-0.03125v1.375c0 0.1875 0.046875 0.26562 0.10938 0.26562 0.046875 0 0.34375-0.10938 0.34375-1.2969v-1.8594c0-0.14062 0.03125-0.25 0.03125-0.3125 0-0.078125-0.03125-0.125-0.21875-0.15625-0.23438-0.0625-0.45312-0.15625-0.78125-0.17188-0.14062 0.015625-0.20312 0.03125-0.20312 0.078125 0 0.03125 0.078125 0.078125 0.20312 0.125 0.28125 0.125 0.5 0.26562 0.51562 0.4375zm1.2812 1.6094c0 0.14062 0.046875 0.21875 0.10938 0.21875s0.14062-0.078125 0.20312-0.20312c0.125-0.3125 0.1875-0.75 0.1875-1.8281v-1.4219c0-0.10938 0.015625-0.1875 0.015625-0.25 0-0.078125-0.03125-0.125-0.1875-0.1875-0.4375-0.125-0.625-0.1875-0.92188-0.21875-0.17188 0-0.21875 0.03125-0.21875 0.0625s0.078125 0.09375 0.1875 0.125c0.32812 0.15625 0.625 0.35938 0.625 0.48438zm-0.09375 2.875c0 0.1875 0.046875 0.28125 0.10938 0.28125 0.09375 0 0.1875-0.125 0.25-0.34375 0.10938-0.46875 0.10938-0.90625 0.10938-1.9375 0-0.09375 0.078125-0.1875 0.078125-0.25 0-0.046875-0.0625-0.09375-0.34375-0.10938h-0.125c-0.21875 0-0.20312 0.078125-0.39062 0.078125-0.60938 0.03125-1.4531 0.0625-2.1875 0.0625-0.45312 0-0.875-0.015625-1.1562-0.0625h-0.09375c-0.078125 0-0.10938 0.015625-0.10938 0.03125 0 0.09375 0.5625 0.375 0.76562 0.375 0.15625 0 0.20312-0.10938 0.5-0.125 0.92188-0.03125 2.125-0.078125 2.5938-0.09375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625-5.0469c-0.4375 0.90625-1.7031 2.1094-2.7969 2.5781-0.125 0.0625-0.1875 0.10938-0.1875 0.14062 0 0.015625 0.03125 0.03125 0.0625 0.03125 0.15625 0 1.6875-0.54688 2.8594-1.8125 0.78125 0.5 2.0312 1.0938 2.5938 1.375 0.09375 0.0625 0.1875 0.078125 0.26562 0.078125 0.10938 0 0.15625-0.046875 0.15625-0.14062 0-0.078125-0.0625-0.20312-0.21875-0.3125-1.1719-0.78125-1-0.40625-1.5156-0.60938-0.32812-0.125-0.8125-0.35938-1.125-0.54688 0.078125-0.14062 0.57812-0.78125 0.57812-0.92188 0-0.046875-0.015625-0.078125-0.078125-0.14062-0.39062-0.23438-0.64062-0.32812-0.95312-0.40625-0.20312 0-0.26562 0.03125-0.26562 0.0625 0 0.046875 0.046875 0.078125 0.10938 0.125 0.29688 0.1875 0.51562 0.34375 0.51562 0.5zm1.7031 4.4062c-1.1875 0.015625-2.3281 0.0625-3.2344 0.0625-0.64062 0-1.1719-0.015625-1.4688-0.10938-0.0625-0.015625-0.125-0.015625-0.17188-0.015625-0.0625 0-0.078125 0.015625-0.078125 0.03125 0 0.14062 0.85938 0.48438 1 0.48438 0.125 0 0.15625-0.09375 0.42188-0.15625 0.96875-0.0625 1.9375-0.09375 2.8906-0.09375 0.6875 0 1.5 0 2.1094 0.046875h0.03125c0.15625 0 0.25-0.078125 0.25-0.17188 0-0.25-0.59375-0.26562-0.78125-0.26562-0.39062 0-0.35938 0.14062-0.67188 0.15625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.5625-5.0625c-0.73438 0.015625-1.6875 0.0625-2.5156 0.0625-0.51562 0-0.98438-0.015625-1.2812-0.0625-0.078125-0.015625-0.125-0.015625-0.17188-0.015625-0.0625 0-0.078125 0.015625-0.078125 0.03125 0 0.09375 0.67188 0.4375 0.85938 0.4375 0.125 0 0.1875-0.078125 0.42188-0.125 1.25-0.0625 2.4844-0.10938 3.0312-0.125-0.03125 0.42188-0.125 1.0781-0.17188 1.2656-0.71875 0.15625-2.2344 0.375-3.3906 0.375-0.32812 0-0.60938-0.015625-0.85938-0.0625-0.0625 0-0.10938-0.015625-0.14062-0.015625-0.0625 0-0.10938 0.015625-0.10938 0.046875 0 0.15625 0.89062 0.51562 1.0625 0.51562 0.125 0 0.15625-0.078125 0.32812-0.125 1.2656-0.1875 2.3125-0.40625 3.0938-0.60938-0.125 0.79688-0.3125 1.5469-0.39062 1.7812-0.03125 0.078125-0.046875 0.15625-0.046875 0.1875 0 0.046875 0.015625 0.0625 0.046875 0.0625s0.10938-0.0625 0.1875-0.17188c0.5-0.76562 0.79688-2.6719 0.92188-3.1875 0.015625-0.046875 0.17188-0.125 0.17188-0.20312 0-0.125-0.39062-0.125-0.48438-0.125-0.29688 0-0.23438 0.03125-0.45312 0.0625zm-2.1094 4.4688c-0.39062 0.015625-0.73438 0.015625-1.0469 0.015625-0.70312 0-1.25-0.03125-1.8125-0.125h-0.09375c-0.078125 0-0.10938 0.015625-0.10938 0.046875 0 0.125 0.84375 0.46875 1.0156 0.46875 0.14062 0 0.21875-0.078125 0.5-0.15625 0.79688-0.046875 1.7031-0.078125 2.5781-0.078125 0.84375 0 1.6562 0.03125 2.3125 0.078125h0.078125c0.20312 0 0.29688-0.0625 0.29688-0.15625 0-0.26562-0.64062-0.32812-0.875-0.32812-0.28125 0-0.25 0.09375-0.73438 0.17188-0.875 0.046875-1.2344 0.0625-1.6562 0.0625l0.015625-1.5c0-0.0625 0.015625-0.125 0.015625-0.15625 0-0.10938-0.09375-0.15625-0.75-0.21875-0.15625 0.015625-0.20312 0.03125-0.20312 0.078125 0 0.03125 0.03125 0.0625 0.10938 0.078125 0.25 0.125 0.34375 0.1875 0.35938 0.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.625-2.2656c-1.1562 0.57812-2.5469 0.82812-3.4375 0.92188h-0.078125c-0.14062 0-0.1875-0.0625-0.20312-0.17188 0.015625-0.48438 0.015625-0.76562 0.015625-1.3125v-0.03125c0-0.15625 0.046875-0.10938 0.1875-0.15625 0.5-0.0625 1.2656-0.09375 1.8125-0.10938 0.14062-0.015625 0.20312-0.0625 0.20312-0.10938 0-0.078125-0.10938-0.15625-0.35938-0.1875 0.078125-0.32812 0.25-1.0156 0.32812-1.3438 0.046875-0.09375 0.17188-0.17188 0.17188-0.25 0-0.0625-0.14062-0.10938-0.39062-0.10938-0.48438 0-0.29688 0.0625-0.57812 0.09375-0.48438 0.03125-0.875 0.046875-1.2344 0.046875-0.34375 0-0.64062-0.015625-0.92188-0.046875-0.03125-0.015625-0.0625-0.015625-0.09375-0.015625-0.078125 0-0.10938 0.015625-0.10938 0.046875 0 0.10938 0.64062 0.39062 0.78125 0.39062 0.10938 0 0.14062-0.078125 0.32812-0.10938 0.48438-0.0625 0.98438-0.10938 1.5156-0.125-0.015625 0.48438-0.0625 1.0469-0.09375 1.4375-0.15625 0.046875-0.20312 0.09375-0.39062 0.10938-0.29688 0.03125-0.75 0.0625-1.1406 0.078125-0.15625-0.078125-0.53125-0.14062-0.92188-0.15625-0.1875 0.046875-0.26562 0.09375-0.26562 0.15625 0 0.03125 0.03125 0.0625 0.14062 0.09375 0.25 0.078125 0.51562 0.14062 0.53125 0.39062l0.03125 1.3125c0 0.26562 0.21875 0.5625 0.375 0.5625 0.5 0 2.6094-0.59375 3.7969-1.2188v2.4062c0 0.23438 0.046875 0.3125 0.10938 0.3125 0.046875 0 0.09375-0.046875 0.14062-0.125 0.14062-0.29688 0.1875-0.48438 0.1875-1.8594v-4.4219c0-0.078125 0.03125-0.14062 0.03125-0.20312s-0.03125-0.10938-0.14062-0.15625c-0.17188-0.0625-0.4375-0.17188-0.90625-0.25-0.17188 0.015625-0.25 0.0625-0.25 0.10938 0 0.03125 0.0625 0.078125 0.15625 0.10938 0.4375 0.1875 0.65625 0.375 0.67188 0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125-1.5781c0 0.015625 0.015625 0.03125 0.03125 0.03125 0.10938 0 1.1875-0.59375 2.2031-1.9375 0.5625 0.73438 1.0312 1.3125 1.2969 1.6406 0.046875 0.0625 0.125 0.09375 0.17188 0.09375 0.09375 0 0.1875-0.078125 0.1875-0.20312 0-0.078125-0.046875-0.17188-0.125-0.29688-0.375-0.625-0.375-0.45312-0.67188-0.67188-0.26562-0.1875-0.57812-0.46875-0.73438-0.75 0.20312-0.34375 0.4375-0.71875 0.57812-1.0625 0.03125-0.046875 0.046875-0.10938 0.046875-0.14062 0-0.1875-0.57812-0.42188-0.875-0.53125-0.09375-0.015625-0.17188-0.03125-0.25-0.03125-0.09375 0-0.15625 0.03125-0.15625 0.078125 0 0.03125 0.046875 0.09375 0.17188 0.15625 0.40625 0.26562 0.48438 0.375 0.48438 0.45312 0 0-0.015625 0.078125-0.03125 0.125-0.57812 1.4219-1.4375 2.2812-2.2031 2.9062-0.078125 0.0625-0.125 0.10938-0.125 0.14062zm5.3125-2.1406c-0.64062 0.015625-0.92188 0.03125-1.25 0.03125-0.14062 0-0.28125 0-0.45312-0.015625h-0.125c-0.0625 0-0.09375 0.015625-0.09375 0.03125 0 0.125 0.51562 0.29688 0.60938 0.29688 0.078125 0 0.078125-0.046875 0.26562-0.078125l1.0469-0.015625v3.6406c0 0.34375 0.0625 0.54688 0.15625 0.54688 0.10938 0 0.29688-0.3125 0.29688-1.3438l0.015625-5.0156c0-0.14062 0.0625-0.23438 0.0625-0.3125 0-0.0625-0.0625-0.125-0.26562-0.20312-0.15625-0.0625-0.6875-0.21875-0.98438-0.21875-0.15625 0.03125-0.20312 0.0625-0.20312 0.09375 0 0.0625 0.14062 0.10938 0.23438 0.14062 0.3125 0.14062 0.6875 0.32812 0.6875 0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7344-5.6719c0.67188 0 1.0156 0.42188 1.0156 0.875 0 0.4375-0.34375 0.85938-1.0156 0.85938-0.73438 0-1.1094-0.42188-1.1094-0.85938 0-0.45312 0.375-0.875 1.1094-0.875zm0.20312-0.3125c0-0.0625 0.046875-0.125 0.046875-0.1875 0-0.10938-0.29688-0.20312-0.42188-0.20312-0.046875 0-0.0625 0.015625-0.0625 0.046875 0 0.015625 0.03125 0.0625 0.0625 0.10938s0.0625 0.09375 0.0625 0.14062c0 0.0625-0.046875 0.10938-0.125 0.10938l-0.0625 0.03125c-0.84375 0.14062-1.2344 0.65625-1.2344 1.1406 0 0.59375 0.5625 1.1562 1.5312 1.1562 0.90625 0 1.4219-0.57812 1.4219-1.1406 0-0.5-0.375-1.0156-1.2188-1.1719zm-1.75 5.9844c0 0.21875 0.10938 0.40625 0.65625 0.40625h2.9688c0.17188 0 0.26562-0.078125 0.26562-0.17188 0-0.21875-0.375-0.21875-0.59375-0.21875-0.45312 0-0.3125 0.15625-0.76562 0.20312-0.4375 0-0.89062 0.015625-1.25 0.015625-0.26562 0-0.48438-0.015625-0.64062-0.015625-0.10938 0-0.1875-0.03125-0.1875-0.17188v-0.64062c0-0.09375 0.0625-0.078125 0.14062-0.125 0.78125-0.015625 1.875-0.046875 2.4531-0.0625 0.17188 0 0.25-0.046875 0.25-0.09375 0-0.0625-0.09375-0.14062-0.29688-0.17188 0.03125-0.14062 0.15625-0.48438 0.23438-0.71875 0.03125-0.078125 0.09375-0.15625 0.09375-0.21875 0-0.03125 0-0.10938-0.46875-0.10938-0.14062 0-0.14062 0.03125-0.26562 0.0625-0.29688 0.015625-0.625 0.046875-0.95312 0.046875 0.15625-0.125 0.15625-0.70312 0.17188-0.98438 0.3125-0.015625 0.875-0.03125 1.4531-0.03125 0.51562 0 1.0312 0.015625 1.3594 0.03125h0.03125c0.14062 0 0.23438-0.078125 0.23438-0.17188 0-0.25-0.4375-0.25-0.67188-0.25-0.39062 0-0.28125 0.078125-0.59375 0.14062-0.65625 0.078125-3.5312 0.125-3.7344 0.125-0.64062 0-1.1562-0.015625-1.4844-0.078125-0.03125 0-0.078125-0.015625-0.10938-0.015625-0.0625 0-0.09375 0.015625-0.09375 0.046875 0 0.14062 0.84375 0.45312 1.0156 0.45312s0.1875-0.125 0.5-0.17188c0.4375-0.015625 1.1406-0.046875 1.6406-0.078125v0.8125c0 0.078125 0.015625 0.125 0.015625 0.1875-0.23438 0-0.46875 0.015625-0.70312 0.015625-0.39062 0-0.73438-0.015625-0.98438-0.046875-0.046875-0.015625-0.078125-0.015625-0.10938-0.015625-0.078125 0-0.10938 0.015625-0.10938 0.046875 0 0.09375 0.57812 0.32812 0.73438 0.32812 0.125 0 0.15625-0.078125 0.375-0.125 0.71875-0.03125 1.7031-0.0625 2.1875-0.078125-0.015625 0.375-0.015625 0.67188-0.046875 0.82812-0.1875 0.03125-0.21875 0.0625-0.40625 0.078125-0.71875 0.015625-1.0938 0.03125-1.7812 0.03125-0.09375-0.03125-0.46875-0.09375-0.79688-0.09375-0.125 0-0.28125 0.0625-0.28125 0.10938 0 0.03125 0.0625 0.046875 0.14062 0.0625 0.25 0.078125 0.39062 0.10938 0.40625 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5-1.5312s0.015625 0.015625 0.03125 0.015625c0.21875 0 1.5156-0.96875 2.2656-2.0469 0.375 0.4375 1.0625 1.3125 1.2188 1.5156 0.125 0.1875 0.26562 0.28125 0.35938 0.28125 0.078125 0 0.14062-0.078125 0.14062-0.1875 0-0.078125-0.015625-0.17188-0.078125-0.29688-0.28125-0.64062-0.53125-0.54688-0.76562-0.75s-0.48438-0.46875-0.75-0.75c0.09375-0.1875 0.46875-0.875 0.46875-1 0-0.0625-0.015625-0.10938-0.078125-0.125-0.21875-0.17188-0.75-0.40625-0.98438-0.40625-0.15625 0-0.20312 0.03125-0.20312 0.0625 0 0.046875 0.0625 0.09375 0.10938 0.125 0.21875 0.09375 0.54688 0.32812 0.54688 0.4375 0 0.20312-0.65625 1.7188-2.1406 2.9531-0.09375 0.078125-0.14062 0.14062-0.14062 0.17188zm5.125 1.8594c0 0.23438 0.046875 0.3125 0.10938 0.3125 0.046875 0 0.09375-0.046875 0.14062-0.125 0.14062-0.29688 0.1875-0.48438 0.1875-1.8594v-4.4219c0-0.078125 0.03125-0.14062 0.03125-0.20312s-0.03125-0.10938-0.14062-0.15625c-0.17188-0.0625-0.4375-0.17188-0.90625-0.25-0.17188 0.015625-0.25 0.0625-0.25 0.10938 0 0.03125 0.0625 0.078125 0.15625 0.10938 0.4375 0.1875 0.65625 0.375 0.67188 0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.25-1.8438c0.70312 0 1.0469 0.5 1.0469 0.98438s-0.34375 0.98438-1.0469 0.98438c-0.6875 0-1.0469-0.5-1.0469-0.98438s0.35938-0.98438 1.0469-0.98438zm-0.26562-0.21875c-0.8125 0.10938-1.2031 0.67188-1.2031 1.2344 0 0.64062 0.5 1.2812 1.4531 1.2812 0.9375 0 1.4688-0.64062 1.4688-1.2656 0-0.54688-0.39062-1.0938-1.2188-1.25 0.03125-0.09375 0.10938-0.15625 0.10938-0.21875 0-0.125-0.35938-0.26562-0.48438-0.26562-0.0625 0-0.09375 0.03125-0.09375 0.0625s0.015625 0.0625 0.0625 0.09375c0.0625 0.0625 0.09375 0.125 0.09375 0.17188 0 0.078125-0.046875 0.125-0.10938 0.14062zm-0.625-3.0938c-0.35938 0.92188-1.6406 2.3438-2.7031 3.0312-0.14062 0.09375-0.21875 0.15625-0.21875 0.1875 0 0.015625 0.015625 0.015625 0.03125 0.015625 0.03125 0 0.10938-0.03125 0.25-0.09375 1.4844-0.76562 2.5156-1.8438 3.1875-3.0625 0.0625-0.09375 0.1875-0.17188 0.1875-0.23438 0-0.09375-0.32812-0.125-0.48438-0.125-0.23438 0-0.20312 0.0625-0.42188 0.078125-0.375 0.015625-0.75 0.03125-1.125 0.03125s-0.73438-0.015625-1.0469-0.046875c-0.078125-0.015625-0.125-0.03125-0.17188-0.03125-0.0625 0-0.09375 0.015625-0.09375 0.046875 0 0.10938 0.5625 0.375 0.75 0.375 0.14062 0 0.17188-0.09375 0.4375-0.125zm1.9219 2.7969c0 0.25 0.0625 0.32812 0.125 0.32812s0.15625-0.10938 0.21875-0.25c0.078125-0.21875 0.125-0.53125 0.125-1.1719l1.2812-0.03125c0.125 0 0.21875-0.09375 0.21875-0.1875 0-0.20312-0.29688-0.20312-0.46875-0.20312-0.53125 0-0.39062 0.14062-0.73438 0.21875-0.10938 0.015625-0.1875 0-0.28125 0.015625v-2.0781c0-0.09375 0.03125-0.15625 0.03125-0.21875s-0.03125-0.10938-0.1875-0.17188c-0.25-0.078125-0.51562-0.15625-0.875-0.20312-0.17188 0.015625-0.26562 0.046875-0.26562 0.09375 0 0.03125 0.0625 0.078125 0.17188 0.10938 0.4375 0.1875 0.64062 0.34375 0.64062 0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.2812-3.9062c-1.2656 0.53125-3.2188 0.6875-3.4062 0.6875-0.21875 0-0.21875-0.10938-0.21875-0.3125 0-0.29688 0.03125-0.9375 0.03125-1.4219 0-0.03125 0.015625-0.10938 0.015625-0.125 0-0.10938-0.125-0.17188-1.0156-0.21875-0.1875 0.046875-0.26562 0.078125-0.26562 0.10938s0.078125 0.0625 0.14062 0.0625c0.375 0.09375 0.53125 0.1875 0.625 0.29688l0.03125 1.4375c0 0.3125 0.14062 0.53125 0.28125 0.53125 0.95312 0.015625 2.8281-0.51562 3.7812-0.89062v1.1406c0 0.21875 0.0625 0.3125 0.125 0.3125s0.32812-0.14062 0.34375-1.2656l1.2812-0.015625c0.125-0.015625 0.21875-0.10938 0.21875-0.1875 0-0.20312-0.29688-0.20312-0.45312-0.20312-0.54688 0-0.35938 0.15625-0.75 0.20312-0.10938 0.015625-0.1875 0.015625-0.28125 0.015625v-2.0312c0-0.078125 0.03125-0.14062 0.03125-0.20312s-0.046875-0.125-0.26562-0.20312c-0.20312-0.046875-0.4375-0.15625-0.79688-0.1875-0.17188 0.015625-0.26562 0.046875-0.26562 0.09375s0.0625 0.09375 0.17188 0.125c0.45312 0.17188 0.64062 0.32812 0.64062 0.40625zm-2.3281 2.3125c0-0.078125 0.078125-0.09375 0.10938-0.10938l2.1719-0.03125-0.09375 1.5938c-0.23438 0.0625-0.1875 0.09375-0.45312 0.10938l-1.7031 0.03125-0.03125-1.25zm-0.375 1.8281c0 0.29688 0.0625 0.42188 0.15625 0.42188 0.078125 0 0.20312-0.17188 0.26562-0.46875h2.5469c0.15625 0 0.25-0.0625 0.25-0.14062s-0.125-0.17188-0.375-0.1875c0.03125-0.23438 0.20312-0.98438 0.34375-1.5469 0.03125-0.078125 0.10938-0.15625 0.10938-0.20312 0-0.09375-0.29688-0.125-0.4375-0.125-0.17188 0-0.20312 0.046875-0.375 0.0625l-2.0469 0.046875c-0.14062-0.046875-0.57812-0.125-0.9375-0.125-0.15625 0.046875-0.21875 0.078125-0.21875 0.10938s0.078125 0.0625 0.17188 0.078125c0.28125 0.125 0.40625 0.17188 0.4375 0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.3594-5.2969c-0.03125 0.46875-0.23438 1.5469-0.375 1.9531-1.0312 0.046875-1.9844 0.09375-2.8281 0.09375-0.57812 0-1.0938-0.015625-1.5156-0.078125h-0.10938c-0.0625 0-0.09375 0-0.09375 0.03125 0 0.10938 0.8125 0.42188 0.96875 0.42188 0.125 0 0.17188-0.09375 0.48438-0.14062 0.35938-0.015625 0.9375-0.046875 1.7031-0.09375v3.3594c0 0.1875 0.046875 0.29688 0.125 0.29688 0.03125 0 0.0625-0.03125 0.10938-0.09375 0.14062-0.23438 0.21875-0.48438 0.21875-1.3438l0.015625-2.2344c0.51562-0.015625 1.0469-0.03125 1.5469-0.03125 0.39062 0 0.76562 0 1.1094 0.03125h0.09375c0.17188 0 0.28125-0.0625 0.28125-0.14062 0-0.10938-0.15625-0.21875-0.42188-0.25-0.10938 0-0.1875-0.015625-0.25-0.015625-0.40625 0-0.28125 0.14062-0.65625 0.15625-0.1875 0-0.375 0.015625-0.5625 0.015625 0.28125-0.59375 0.5625-1.6094 0.71875-2.1875 0.03125-0.078125 0.1875-0.15625 0.1875-0.23438 0-0.09375-0.39062-0.14062-0.57812-0.14062s-0.17188 0.0625-0.4375 0.078125c-0.875 0.03125-1.7031 0.0625-2.3906 0.0625-0.45312 0-0.875-0.015625-1.2031-0.078125-0.046875 0-0.09375-0.015625-0.14062-0.015625-0.0625 0-0.078125 0.015625-0.078125 0.046875 0 0.078125 0.625 0.39062 0.8125 0.39062 0.14062 0 0.1875-0.09375 0.48438-0.125 0.84375-0.0625 1.8906-0.09375 2.8125-0.10938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.0156-4.25c-0.03125-0.46875-0.4375-1-1.3281-1.1094 0.03125-0.078125 0.125-0.14062 0.125-0.23438 0-0.10938-0.26562-0.23438-0.45312-0.23438-0.0625 0-0.09375 0.015625-0.09375 0.03125 0 0.046875 0.03125 0.09375 0.09375 0.14062 0.03125 0.03125 0.03125 0.0625 0.03125 0.10938 0 0.09375-0.0625 0.15625-0.20312 0.17188l-0.046875 0.015625c-0.82812 0.125-1.2344 0.6875-1.2344 1.2656 0 0.64062 0.51562 1.3125 1.5312 1.3125 0.96875 0 1.5-0.51562 1.5781-1.2344zm-1.5938-0.82812c0.78125 0 1.1719 0.5 1.1719 1 0 0.51562-0.39062 1-1.1719 1-0.71875 0-1.0781-0.48438-1.0781-1 0-0.5 0.35938-1 1.0781-1zm2.0469 3.4219c0.70312 0 1.0469 0.46875 1.0469 0.92188s-0.34375 0.92188-1.0469 0.92188-1.0625-0.46875-1.0625-0.92188 0.35938-0.92188 1.0625-0.92188zm-0.1875-0.23438c-0.875 0.10938-1.2812 0.67188-1.2812 1.2031 0 0.60938 0.5 1.2188 1.4375 1.2188 0.95312 0 1.4844-0.60938 1.4844-1.2188 0-0.51562-0.39062-1.0469-1.2344-1.2031 0.03125-0.09375 0.125-0.15625 0.125-0.21875 0-0.10938-0.34375-0.25-0.5-0.25-0.0625 0-0.09375 0.015625-0.09375 0.046875s0.03125 0.0625 0.078125 0.09375c0.046875 0.0625 0.09375 0.14062 0.09375 0.20312s-0.046875 0.10938-0.10938 0.125zm1.3438-2.9375c-0.375 0.015625-0.5625 0.03125-0.90625 0.03125h-0.45312c-0.078125-0.015625-0.125-0.015625-0.15625-0.015625-0.0625 0-0.09375 0-0.09375 0.03125 0 0.125 0.54688 0.29688 0.65625 0.29688s0.10938-0.0625 0.28125-0.078125c0.125-0.015625 0.35938-0.046875 0.67188-0.046875v1.125c-0.35938 0.03125-0.73438 0.046875-1.1094 0.046875h-0.375c-0.078125 0-0.125 0.015625-0.125 0.03125 0 0.0625 0.5 0.29688 0.64062 0.29688 0.09375 0 0.10938-0.0625 0.25-0.09375 0.23438-0.015625 0.5-0.03125 0.71875-0.046875v0.90625c0 0.26562 0.046875 0.4375 0.125 0.4375 0.046875 0 0.09375-0.046875 0.15625-0.15625 0.10938-0.21875 0.17188-0.35938 0.17188-1.3594l0.03125-2.2969c0-0.09375 0.03125-0.15625 0.03125-0.23438 0-0.0625-0.046875-0.14062-0.25-0.21875-0.15625-0.046875-0.67188-0.17188-0.89062-0.17188-0.046875 0-0.23438 0.046875-0.23438 0.09375s0.14062 0.09375 0.21875 0.10938c0.34375 0.15625 0.64062 0.34375 0.64062 0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438-4.3906c0.015625 0.29688 0.1875 0.48438 0.75 0.48438h0.9375c0 0.3125 0.015625 0.78125 0.03125 1.125-0.48438 0.03125-0.98438 0.0625-1.4688 0.0625-0.57812 0-1.1094-0.03125-1.5-0.09375-0.046875 0-0.09375-0.015625-0.14062-0.015625-0.0625 0-0.078125 0.015625-0.078125 0.046875 0 0.15625 0.76562 0.5 0.96875 0.5 0.15625 0 0.23438-0.10938 0.54688-0.15625 1.0625-0.14062 2.3438-0.1875 3.375-0.1875 0.64062 0 1.1875 0.015625 1.5469 0.03125h0.03125c0.17188 0 0.26562-0.078125 0.26562-0.17188s-0.09375-0.1875-0.3125-0.21875c-0.28125-0.046875-0.45312-0.0625-0.57812-0.0625-0.28125 0-0.23438 0.09375-0.59375 0.14062-0.46875 0.046875-1.0938 0.09375-1.6875 0.10938 0.0625-0.3125 0.078125-0.6875 0.078125-1.1406 0.40625 0 1.3125-0.015625 1.5781-0.03125 0.17188 0 0.28125-0.10938 0.28125-0.20312s-0.09375-0.1875-0.35938-0.1875c-0.71875 0-0.48438 0.14062-0.90625 0.20312-0.60938 0.046875-1.0469 0.0625-1.4375 0.0625-0.79688 0-0.82812 0-0.84375-0.26562-0.015625-0.32812-0.015625-0.85938-0.015625-1.1719 0-0.125 0.03125-0.09375 0.09375-0.14062 0.75 0 2.25-0.015625 3.0312-0.0625 0.23438 0 0.35938-0.078125 0.35938-0.17188 0-0.1875-0.39062-0.1875-0.54688-0.1875-0.59375 0-0.32812 0.14062-0.92188 0.1875-0.73438 0.046875-1.4219 0.046875-2 0.046875-0.20312-0.09375-0.5625-0.14062-0.95312-0.15625-0.125 0.015625-0.20312 0.046875-0.20312 0.078125s0.03125 0.046875 0.10938 0.0625c0.3125 0.10938 0.53125 0.17188 0.5625 0.34375zm1.9219 2.7344c0.70312 0 1.0625 0.46875 1.0625 0.92188s-0.35938 0.92188-1.0625 0.92188c-0.6875 0-1.0469-0.46875-1.0469-0.92188s0.35938-0.92188 1.0469-0.92188zm-0.1875-0.23438c-0.85938 0.10938-1.2656 0.65625-1.2656 1.1875 0 0.64062 0.5 1.2344 1.4375 1.2344s1.4688-0.60938 1.4688-1.2344c0-0.51562-0.39062-1.0312-1.2188-1.1875 0.03125-0.09375 0.10938-0.15625 0.10938-0.21875 0-0.10938-0.34375-0.25-0.48438-0.25-0.0625 0-0.09375 0.015625-0.09375 0.046875s0.03125 0.0625 0.0625 0.09375c0.0625 0.0625 0.09375 0.14062 0.09375 0.20312s-0.03125 0.10938-0.10938 0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5-2.3438c-0.71875 0.34375-1.9844 0.64062-2.4531 0.64062-0.1875 0-0.20312-0.03125-0.20312-0.1875v-2.375c0-0.14062 0.0625-0.078125 0.09375-0.125 0.34375 0 1.0156-0.015625 1.4531-0.046875 0.14062 0 0.20312-0.078125 0.20312-0.15625 0-0.09375-0.10938-0.20312-0.375-0.20312-0.59375 0-0.40625 0.125-0.73438 0.1875-0.14062 0.015625-0.29688 0.015625-0.4375 0.015625h-0.21875c-0.25-0.0625-0.53125-0.125-0.85938-0.125-0.17188 0.03125-0.21875 0.0625-0.21875 0.10938 0 0.03125 0.046875 0.0625 0.125 0.078125 0.3125 0.125 0.46875 0.1875 0.48438 0.35938l0.03125 2.375c0.015625 0.20312 0.125 0.5625 0.39062 0.5625 0.03125 0 1.25-0.17188 2.7188-0.95312v1.9219c0 0.29688 0.0625 0.4375 0.14062 0.4375 0.10938 0 0.23438-0.21875 0.26562-0.59375l0.03125-2.2031 0.95312-0.015625v2.9219c0 0.25 0.0625 0.375 0.125 0.375 0.10938 0 0.25-0.25 0.29688-0.71875l0.03125-5.6562c0-0.078125 0.015625-0.14062 0.015625-0.1875 0-0.125-0.125-0.21875-0.96875-0.4375-0.1875 0-0.26562 0.03125-0.26562 0.078125 0 0.03125 0.09375 0.078125 0.15625 0.125 0.34375 0.17188 0.59375 0.34375 0.60938 0.5v2.7812l-0.95312 0.015625v-2.5625c0-0.046875 0.015625-0.10938 0.015625-0.15625 0-0.10938-0.10938-0.21875-0.9375-0.35938-0.15625 0.015625-0.23438 0.046875-0.23438 0.09375 0 0.015625 0.078125 0.0625 0.17188 0.10938 0.32812 0.15625 0.53125 0.28125 0.54688 0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.7812-0.39062c0.1875 0 0.29688-0.078125 0.29688-0.17188 0-0.26562-0.70312-0.3125-0.89062-0.3125-0.34375 0-0.29688 0.125-0.59375 0.14062-0.65625 0.046875-1.2656 0.0625-1.6094 0.0625 0.015625-0.34375 0.015625-0.64062 0.015625-1.7031 0.48438-0.015625 0.98438-0.046875 1.6562-0.09375 0.14062 0 0.25-0.09375 0.25-0.17188 0-0.17188-0.29688-0.1875-0.48438-0.1875-0.54688 0-0.375 0.1875-0.78125 0.21875-0.75 0.0625-1.4688 0.09375-2 0.09375-0.17188-0.015625-0.20312-0.046875-0.21875-0.17188 0-0.40625 0-0.8125 0.015625-0.95312v-0.015625c0-0.10938 0.046875-0.0625 0.15625-0.09375 0.78125-0.03125 1.7969-0.10938 2.8281-0.14062 0.125 0 0.1875-0.046875 0.1875-0.09375 0-0.0625-0.125-0.14062-0.32812-0.15625 0.078125-0.23438 0.23438-0.6875 0.29688-0.95312 0.046875-0.10938 0.20312-0.21875 0.20312-0.3125 0-0.078125-0.17188-0.10938-0.51562-0.10938-0.28125 0-0.29688 0.046875-0.5 0.078125-0.73438 0.0625-1.4844 0.10938-2.1562 0.10938-0.39062 0-0.75-0.015625-1.0938-0.0625h-0.09375c-0.0625 0-0.078125 0.015625-0.078125 0.03125 0 0.10938 0.67188 0.39062 0.79688 0.39062 0.10938 0 0.14062-0.09375 0.39062-0.125 0.89062-0.0625 1.9375-0.14062 2.5781-0.17188-0.015625 0.42188-0.0625 0.9375-0.09375 1.125-0.25 0.046875-0.28125 0.078125-0.51562 0.09375-0.57812 0.046875-1.6562 0.09375-2.0625 0.10938-0.23438-0.0625-0.5-0.09375-0.78125-0.09375-0.3125 0-0.39062 0.0625-0.39062 0.09375 0 0.046875 0.046875 0.078125 0.10938 0.078125 0.28125 0.078125 0.53125 0.14062 0.5625 0.28125l0.015625 0.78125c0.015625 0.34375 0.26562 0.45312 0.57812 0.46875 0.26562 0 0.59375-0.015625 1-0.03125 0.015625 1.2969 0.015625 1.5781 0.015625 1.7188-0.51562 0.015625-0.98438 0.03125-1.4062 0.03125-0.625 0-1.1562-0.03125-1.5469-0.10938-0.0625-0.015625-0.125-0.015625-0.15625-0.015625-0.0625 0-0.09375 0.015625-0.09375 0.03125 0 0.046875 0.046875 0.09375 0.15625 0.14062 0.45312 0.25 0.67188 0.32812 0.82812 0.32812 0.17188 0 0.25-0.09375 0.48438-0.10938 0.625-0.0625 1.2812-0.125 2.5938-0.125 0.92188 0 1.7656 0.046875 2.3438 0.078125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7969-2.8281c0 0.32812 0.23438 0.51562 0.6875 0.51562 1.6406-0.015625 2.5-0.046875 3.3594-0.078125 0.1875 0 0.3125-0.10938 0.3125-0.20312 0-0.1875-0.32812-0.1875-0.46875-0.1875-0.71875 0-0.45312 0.15625-0.92188 0.20312-0.75 0.046875-1.3125 0.0625-1.8906 0.0625-0.53125 0-0.60938 0-0.625-0.26562v-0.96875c0.95312-0.015625 2.8281-0.046875 3.3438-0.078125 0.17188 0 0.26562-0.09375 0.26562-0.1875s-0.09375-0.17188-0.34375-0.17188c-0.6875 0-0.45312 0.14062-0.78125 0.1875-1.0625 0.03125-1.8438 0.046875-2.4844 0.0625v-1.0469c0-0.10938 0.046875-0.078125 0.125-0.10938 0.64062-0.03125 2.25-0.078125 3.5-0.125 0.14062 0 0.25-0.0625 0.25-0.15625 0-0.046875-0.046875-0.23438-0.57812-0.23438-0.54688 0-0.42188 0.15625-0.8125 0.23438-0.92188 0.03125-1.8125 0.046875-2.4062 0.0625-0.21875-0.078125-0.65625-0.17188-0.98438-0.17188-0.09375 0-0.29688 0.046875-0.29688 0.10938 0 0.046875 0.09375 0.09375 0.1875 0.10938 0.29688 0.09375 0.53125 0.20312 0.53125 0.35938zm3.5 2.1719c-1.0156 0.046875-2.0156 0.09375-2.8438 0.09375-0.8125 0-1.4688-0.046875-1.8281-0.125-0.0625-0.015625-0.09375-0.015625-0.14062-0.015625-0.0625 0-0.09375 0.015625-0.09375 0.03125 0 0.125 0.84375 0.48438 1.0312 0.48438 0.15625 0 0.1875-0.10938 0.46875-0.15625 0.4375-0.015625 1.3281-0.0625 1.9844-0.078125h1.6562c0.4375 0 0.875 0 1.25 0.03125h0.046875c0.15625 0 0.25-0.09375 0.25-0.17188 0-0.26562-0.625-0.29688-0.8125-0.29688-0.42188 0-0.39062 0.15625-0.67188 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156-1.4375c0.03125 0.28125 0.10938 0.53125 0.375 0.53125 0.42188 0 2.25-0.95312 2.25-1.1562 0-0.015625-0.015625-0.03125-0.03125-0.03125-0.03125 0-0.09375 0.015625-0.1875 0.0625-0.64062 0.32812-1.4844 0.65625-1.8281 0.65625-0.125 0-0.125-0.03125-0.125-0.51562 0-0.375 0.015625-0.875 0.015625-1.0469 0-0.14062 0.046875-0.078125 0.10938-0.14062 0.28125-0.03125 0.6875-0.078125 0.98438-0.09375 0.1875-0.015625 0.26562-0.0625 0.26562-0.125s-0.0625-0.125-0.1875-0.15625c0.03125-0.1875 0.17188-0.8125 0.25-1.1406 0.046875-0.09375 0.15625-0.20312 0.15625-0.28125s-0.15625-0.10938-0.375-0.10938c-0.32812 0-0.23438 0.078125-0.45312 0.09375-0.25 0.015625-0.73438 0.0625-1.1719 0.0625-0.17188 0-0.32812 0-0.45312-0.015625-0.046875-0.015625-0.078125-0.015625-0.10938-0.015625-0.0625 0-0.09375 0.015625-0.09375 0.046875 0 0.125 0.57812 0.3125 0.67188 0.3125 0.10938 0 0.14062-0.0625 0.35938-0.10938 0.34375-0.03125 0.60938-0.0625 1-0.078125 0 0.35938-0.03125 0.9375-0.0625 1.2656-0.078125 0.03125-0.15625 0.0625-0.25 0.078125-0.20312 0.03125-0.39062 0.046875-0.625 0.046875-0.14062 0-0.54688-0.0625-0.85938-0.0625-0.125 0-0.26562 0.0625-0.26562 0.10938 0 0.03125 0.0625 0.0625 0.17188 0.09375 0.25 0.078125 0.4375 0.1875 0.45312 0.3125zm3.125-1.75c-0.35938 0.015625-0.70312 0.03125-0.96875 0.03125h-0.10938c-0.0625 0-0.078125 0-0.078125 0.03125 0 0.09375 0.375 0.25 0.45312 0.25 0.046875 0 0.078125-0.046875 0.23438-0.078125 0.09375-0.015625 0.26562-0.03125 0.46875-0.046875v2.6406c0 0.29688 0.046875 0.40625 0.10938 0.40625 0.09375 0 0.3125-0.1875 0.3125-1.0469l0.015625-4.3125c0-0.03125 0.015625-0.15625 0.015625-0.17188 0-0.125-0.125-0.23438-0.9375-0.35938-0.15625 0.015625-0.21875 0.046875-0.21875 0.078125 0 0.046875 0.0625 0.078125 0.1875 0.14062 0.15625 0.0625 0.48438 0.21875 0.51562 0.39062zm1.1875 3.4062c0 0.35938 0.0625 0.4375 0.14062 0.4375 0.125 0 0.28125-0.28125 0.29688-1.0938l0.015625-5.2969c0-0.078125 0.03125-0.15625 0.03125-0.21875 0-0.125-0.125-0.25-0.90625-0.42188-0.21875 0-0.29688 0.03125-0.29688 0.078125 0 0.03125 0.0625 0.078125 0.17188 0.125 0.25 0.14062 0.54688 0.32812 0.54688 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438-3.3438c0.015625 0.39062 0.34375 0.5625 0.59375 0.5625h0.96875c0.90625 0 2.1719 0 2.5156-0.03125 0.1875 0 0.29688-0.078125 0.29688-0.1875 0-0.0625-0.078125-0.20312-0.4375-0.20312-0.67188 0-0.51562 0.20312-1.0156 0.20312-0.4375 0.015625-0.95312 0.03125-1.3906 0.03125-1.0469 0-1.0469 0-1.0469-0.28125v-1.6719c0-0.15625 0.078125-0.125 0.15625-0.15625 0.70312-0.015625 2.0469-0.015625 3.2344-0.0625 0.25 0 0.34375-0.09375 0.34375-0.1875 0-0.10938-0.125-0.21875-0.34375-0.21875h-0.078125c-0.85938 0-0.375 0.1875-1.2188 0.25l-2.0625 0.015625c-0.1875-0.078125-0.5625-0.15625-1.0156-0.1875-0.1875 0.015625-0.25 0.046875-0.25 0.09375 0 0.03125 0.0625 0.078125 0.14062 0.09375 0.29688 0.10938 0.59375 0.23438 0.60938 0.39062zm3.4844 2.7031c-1.1875 0.015625-2.3281 0.0625-3.2344 0.0625-0.64062 0-1.1719-0.015625-1.4688-0.10938-0.0625-0.015625-0.125-0.015625-0.17188-0.015625-0.0625 0-0.078125 0.015625-0.078125 0.03125 0 0.14062 0.85938 0.48438 1 0.48438 0.125 0 0.15625-0.09375 0.42188-0.15625 0.96875-0.0625 1.9375-0.09375 2.8906-0.09375 0.6875 0 1.5 0 2.1094 0.046875h0.03125c0.15625 0 0.25-0.078125 0.25-0.17188 0-0.25-0.59375-0.26562-0.78125-0.26562-0.39062 0-0.35938 0.14062-0.67188 0.15625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7812-4.5625c-0.375 1.0781-1.2031 1.8594-1.9062 2.4688-0.10938 0.078125-0.15625 0.14062-0.15625 0.17188 0 0.015625 0.015625 0.015625 0.03125 0.015625 0.15625 0 1.0625-0.57812 1.9375-1.6406 0.375 0.53125 0.65625 1.1406 0.79688 1.4375 0.0625 0.09375 0.125 0.14062 0.20312 0.14062s0.15625-0.09375 0.15625-0.23438v-0.046875c-0.125-0.75-0.35938-0.64062-0.625-0.95312-0.125-0.14062-0.26562-0.3125-0.40625-0.48438 0.42188-0.67188 0.54688-0.98438 0.54688-1.0312 0-0.20312-0.75-0.45312-0.90625-0.45312-0.28125 0-0.25 0.078125-0.10938 0.14062 0.28125 0.17188 0.4375 0.32812 0.4375 0.40625zm1.8125 0.8125c-0.28125 0-0.54688 0-1.0312 0.015625-0.1875 0-0.23438 0-0.23438 0.046875 0 0.10938 0.45312 0.26562 0.54688 0.26562s0.09375-0.0625 0.28125-0.10938l0.4375-0.03125v2.0625c0 0.35938 0.0625 0.54688 0.14062 0.54688 0.015625 0 0.26562 0 0.29688-1.2344v-2.9844c0-0.09375 0.03125-0.15625 0.03125-0.23438 0-0.0625-0.03125-0.14062-0.21875-0.21875-0.20312-0.03125-0.5-0.14062-0.6875-0.15625-0.1875 0.015625-0.25 0.046875-0.25 0.09375 0 0.03125 0.078125 0.078125 0.17188 0.10938 0.23438 0.10938 0.51562 0.26562 0.51562 0.45312zm1.2812 2.5781c0 0.375 0.078125 0.45312 0.14062 0.45312 0.14062-0.03125 0.28125-0.40625 0.29688-1.1094l0.015625-3.875c0-0.078125 0.03125-0.125 0.03125-0.1875s-0.03125-0.10938-0.17188-0.15625c-0.17188-0.078125-0.45312-0.1875-0.82812-0.25-0.17188 0-0.25 0.03125-0.25 0.078125 0 0.03125 0.078125 0.078125 0.17188 0.125 0.3125 0.15625 0.57812 0.34375 0.59375 0.48438zm-2.9688 0.82812c0 0.40625 0.35938 0.51562 0.67188 0.51562h2.9688c0.1875 0 0.28125-0.10938 0.28125-0.21875 0-0.23438-0.3125-0.23438-0.57812-0.23438-0.6875 0-0.078125 0.26562-1.5781 0.26562h-0.95312c-0.3125 0-0.34375-0.078125-0.34375-0.34375v-0.84375-0.1875c0-0.125-0.03125-0.20312-0.28125-0.20312-0.09375 0-0.45312-0.03125-0.53125-0.03125-0.14062 0-0.42188 0.03125-0.42188 0.14062 0 0.03125 0.0625 0.0625 0.20312 0.078125 0.4375 0.09375 0.53125 0.20312 0.54688 0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-1.5781c0.015625 0.17188 0.17188 0.51562 0.40625 0.51562 0.0625 0 1.4531-0.25 2.7969-0.875 0.125-0.078125 0.1875-0.125 0.1875-0.15625 0-0.015625-0.015625-0.03125-0.046875-0.03125-0.046875 0-0.125 0.015625-0.21875 0.0625-0.90625 0.3125-1.6719 0.45312-2.4219 0.53125-0.03125 0.015625-0.0625 0.015625-0.078125 0.015625-0.125 0-0.17188-0.078125-0.17188-0.25v-1.4062c0.53125-0.015625 1.2188-0.046875 1.6875-0.046875 0.20312-0.015625 0.29688-0.10938 0.29688-0.1875 0-0.0625-0.046875-0.1875-0.3125-0.1875-0.6875 0-0.59375 0.17188-0.89062 0.20312-0.29688 0.015625-0.57812 0.015625-0.78125 0.015625v-1.3438c0.015625-0.14062 0.03125-0.078125 0.10938-0.14062 0.375-0.015625 1.1562-0.015625 1.9062-0.03125 0.1875 0 0.28125-0.09375 0.28125-0.1875 0-0.10938-0.10938-0.20312-0.42188-0.20312-0.60938 0-0.42188 0.125-0.76562 0.20312-0.26562 0.015625-0.53125 0.015625-0.76562 0.015625h-0.39062c-0.15625-0.046875-0.5-0.10938-0.85938-0.10938-0.17188 0.046875-0.25 0.09375-0.25 0.125 0 0.046875 0.078125 0.078125 0.17188 0.09375 0.23438 0.078125 0.51562 0.21875 0.51562 0.28125zm4.3438-1.9219c-0.29688 0.03125-0.59375 0.046875-0.9375 0.046875-0.09375 0-0.48438-0.015625-0.5625-0.015625-0.0625 0-0.09375 0.015625-0.09375 0.03125 0 0.0625 0.4375 0.28125 0.54688 0.28125 0.078125 0 0.09375-0.046875 0.26562-0.0625 0.28125-0.046875 0.48438-0.0625 0.78125-0.078125v3.5156c0 0.26562 0.015625 0.42188 0.125 0.42188 0.14062 0 0.3125-0.45312 0.3125-1.25v-5.125c0-0.09375 0.046875-0.17188 0.046875-0.25 0-0.14062-0.15625-0.23438-1.1406-0.39062-0.15625 0-0.23438 0.03125-0.23438 0.078125s0.09375 0.09375 0.21875 0.125c0.21875 0.09375 0.64062 0.29688 0.67188 0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-24-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7656-1.6562c0.70312 0 1.0625 0.46875 1.0625 0.92188s-0.35938 0.92188-1.0625 0.92188c-0.6875 0-1.0469-0.46875-1.0469-0.92188s0.35938-0.92188 1.0469-0.92188zm3.0625-1.0469c0.15625 0 0.26562-0.10938 0.26562-0.20312 0-0.20312-0.3125-0.25-0.71875-0.25-0.42188 0-0.32812 0.15625-0.71875 0.15625-1.3438 0.0625-2.7344 0.14062-3.7656 0.14062-0.5625 0-1.0156-0.03125-1.2656-0.09375-0.0625-0.015625-0.10938-0.015625-0.15625-0.015625-0.0625 0-0.09375 0.015625-0.09375 0.046875 0 0.09375 0.8125 0.45312 0.98438 0.45312 0.14062 0 0.15625-0.09375 0.375-0.14062 0.65625-0.0625 2.1719-0.14062 3.7031-0.14062 0.48438 0 0.96875 0 1.3906 0.046875zm-3.25 0.8125c-0.85938 0.10938-1.2656 0.65625-1.2656 1.1875 0 0.64062 0.5 1.2344 1.4375 1.2344s1.4688-0.60938 1.4688-1.2344c0-0.51562-0.39062-1.0312-1.2188-1.1875 0.03125-0.09375 0.10938-0.15625 0.10938-0.21875 0-0.10938-0.34375-0.25-0.48438-0.25-0.0625 0-0.09375 0.015625-0.09375 0.046875s0.03125 0.0625 0.0625 0.09375c0.0625 0.0625 0.09375 0.14062 0.09375 0.20312s-0.03125 0.10938-0.10938 0.125zm1-3.3438c-0.82812 0.73438-2.2969 1.2656-3.7188 1.5781-0.10938 0.03125-0.17188 0.0625-0.17188 0.078125s0.03125 0.03125 0.09375 0.03125c0.015625 0 0.046875 0 0.09375-0.015625 1.3594-0.20312 2.125-0.45312 2.7969-0.71875 0.53125 0.15625 1.7031 0.32812 2.3594 0.46875 0.046875 0 0.09375 0.015625 0.14062 0.015625 0.14062 0 0.21875-0.0625 0.21875-0.14062 0-0.046875-0.046875-0.125-0.1875-0.17188-0.53125-0.15625-0.73438-0.1875-0.875-0.1875-0.09375 0-0.5 0.03125-0.59375 0.03125-0.28125 0-0.73438-0.046875-0.79688-0.14062 0.53125-0.25 1.0312-0.59375 1.3125-0.75 0.21875-0.09375 0.3125-0.17188 0.3125-0.23438 0-0.078125-0.45312-0.09375-0.59375-0.09375-0.23438 0-0.15625 0.046875-0.39062 0.078125-0.64062 0.03125-1.1875 0.0625-1.6875 0.0625-0.45312 0-0.85938-0.03125-1.2969-0.09375-0.09375-0.015625-0.15625-0.015625-0.20312-0.015625-0.078125 0-0.09375 0.015625-0.09375 0.03125 0 0.125 0.71875 0.39062 0.84375 0.39062 0.10938 0 0.10938-0.0625 0.26562-0.09375 0.53125-0.046875 1.2969-0.09375 1.9062-0.09375zm-1.125-0.71875c0.10938 0.015625 0.3125 0.015625 0.48438 0.015625 0.14062 0 0.53125 0 0.53125-0.1875 0-0.078125-0.09375-0.14062-0.28125-0.14062-0.4375 0-1.0625 0-1.4688-0.10938-0.0625-0.015625-0.10938-0.015625-0.14062-0.015625-0.046875 0-0.0625 0-0.0625 0.015625 0 0.09375 0.5 0.375 0.64062 0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.46875-2.3594 1.6562-0.1875c0.050781 0.41797 0.19141 0.73438 0.42188 0.95312 0.22656 0.21875 0.50781 0.32812 0.84375 0.32812 0.35156 0 0.64844-0.12891 0.89062-0.39062 0.23828-0.26953 0.35938-0.62891 0.35938-1.0781 0-0.42578-0.11719-0.76562-0.34375-1.0156-0.23047-0.25-0.51172-0.375-0.84375-0.375-0.21875 0-0.48047 0.042969-0.78125 0.125l0.1875-1.3906c0.45703 0.023437 0.80469-0.070313 1.0469-0.28125 0.25-0.21875 0.375-0.50391 0.375-0.85938 0-0.28906-0.089844-0.52344-0.26562-0.70312-0.17969-0.1875-0.41797-0.28125-0.71875-0.28125-0.29297 0-0.54297 0.10547-0.75 0.3125-0.21094 0.19922-0.33594 0.49219-0.375 0.875l-1.5781-0.26562c0.11328-0.53125 0.28125-0.95703 0.5-1.2812 0.21875-0.32031 0.52344-0.57031 0.92188-0.75 0.39453-0.1875 0.83594-0.28125 1.3281-0.28125 0.84375 0 1.5195 0.26562 2.0312 0.79688 0.41406 0.4375 0.625 0.93359 0.625 1.4844 0 0.77344-0.42969 1.3906-1.2812 1.8594 0.50781 0.10547 0.91406 0.35156 1.2188 0.73438 0.3125 0.375 0.46875 0.83594 0.46875 1.375 0 0.77344-0.28906 1.4336-0.85938 1.9844-0.57422 0.55469-1.2891 0.82812-2.1406 0.82812-0.8125 0-1.4844-0.22656-2.0156-0.6875-0.53125-0.46875-0.83984-1.0781-0.92188-1.8281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.078125 0 2.3281-3.3125-2.2344-3.1094h2.0938l1.1406 1.7656 1.2031-1.7656h2.0156l-2.2031 3.0469 2.3906 3.375h-2.0938l-1.3125-1.9844-1.3281 1.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.8906 0v-1.7812h-3.6562v-1.4844l3.875-5.6406h1.4375v5.625h1.0938v1.5h-1.0938v1.7812zm0-3.2812v-3.0312l-2.0625 3.0312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.53125-7.1719v-1.5781h5.8438v1.2344c-0.48047 0.46875-0.96875 1.1484-1.4688 2.0312-0.5 0.88672-0.88281 1.8281-1.1406 2.8281-0.26172 0.99219-0.39062 1.875-0.39062 2.6562h-1.6406c0.019531-1.2266 0.26953-2.4766 0.75-3.75 0.48828-1.2695 1.1328-2.4102 1.9375-3.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5312-4.5312-1.6875 0.3125c-0.054688-0.33203-0.18359-0.58203-0.39062-0.75-0.19922-0.17578-0.46094-0.26562-0.78125-0.26562-0.42969 0-0.76562 0.14844-1.0156 0.4375-0.25 0.29297-0.375 0.78125-0.375 1.4688 0 0.76172 0.125 1.3047 0.375 1.625 0.25781 0.3125 0.60938 0.46875 1.0469 0.46875 0.32031 0 0.58594-0.09375 0.79688-0.28125 0.20703-0.1875 0.35156-0.50391 0.4375-0.95312l1.6875 0.29688c-0.17969 0.76172-0.51562 1.3398-1.0156 1.7344-0.49219 0.38672-1.1523 0.57812-1.9844 0.57812-0.94922 0-1.7031-0.29688-2.2656-0.89062s-0.84375-1.4102-0.84375-2.4531c0-1.0625 0.28125-1.8906 0.84375-2.4844s1.3281-0.89062 2.2969-0.89062c0.78125 0 1.4062 0.17188 1.875 0.51562 0.46875 0.33594 0.80078 0.84375 1 1.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562-6.4219h1.5781v0.875c0.5625-0.6875 1.2344-1.0312 2.0156-1.0312 0.41406 0 0.77344 0.089844 1.0781 0.26562 0.30078 0.16797 0.55078 0.42188 0.75 0.76562 0.28125-0.34375 0.58203-0.59766 0.90625-0.76562 0.33203-0.17578 0.6875-0.26562 1.0625-0.26562 0.47656 0 0.87891 0.10156 1.2031 0.29688 0.33203 0.1875 0.57812 0.46875 0.73438 0.84375 0.125 0.27344 0.1875 0.71484 0.1875 1.3281v4.1094h-1.7188v-3.6719c0-0.63281-0.058594-1.0469-0.17188-1.2344-0.15625-0.23828-0.40234-0.35938-0.73438-0.35938-0.24219 0-0.46484 0.074219-0.67188 0.21875-0.21094 0.14844-0.35938 0.35938-0.45312 0.64062-0.09375 0.27344-0.14062 0.71484-0.14062 1.3281v3.0781h-1.7188v-3.5156c0-0.625-0.03125-1.0234-0.09375-1.2031-0.054687-0.1875-0.14844-0.32031-0.28125-0.40625-0.125-0.09375-0.29688-0.14062-0.51562-0.14062-0.26172 0-0.5 0.074219-0.71875 0.21875-0.21094 0.13672-0.35938 0.33984-0.45312 0.60938-0.085937 0.26172-0.125 0.69922-0.125 1.3125v3.125h-1.7188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9062 0h-1.7031v-6.4062c-0.625 0.58594-1.3672 1.0117-2.2188 1.2812v-1.5312c0.44531-0.14453 0.92969-0.42188 1.4531-0.82812 0.53125-0.40625 0.89062-0.87891 1.0781-1.4219h1.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.3125-1.5781v1.5781h-6c0.0625-0.59375 0.25391-1.1562 0.57812-1.6875 0.32031-0.53906 0.96094-1.2539 1.9219-2.1406 0.76953-0.70703 1.2422-1.1914 1.4219-1.4531 0.23828-0.34375 0.35938-0.6875 0.35938-1.0312 0-0.38281-0.10547-0.67578-0.3125-0.875-0.21094-0.20703-0.49219-0.3125-0.84375-0.3125-0.36719 0-0.65234 0.10938-0.85938 0.32812-0.21094 0.21094-0.32812 0.5625-0.35938 1.0625l-1.7031-0.17188c0.09375-0.9375 0.40625-1.6094 0.9375-2.0156 0.53906-0.40625 1.2109-0.60938 2.0156-0.60938 0.88281 0 1.5781 0.24219 2.0781 0.71875 0.50781 0.46875 0.76562 1.0547 0.76562 1.75 0 0.39844-0.074219 0.77734-0.21875 1.1406-0.14844 0.36719-0.375 0.74609-0.6875 1.1406-0.21094 0.26172-0.58594 0.63672-1.125 1.125-0.54297 0.49219-0.88672 0.82031-1.0312 0.98438-0.13672 0.15625-0.25 0.3125-0.34375 0.46875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.89062 0v-1.7031h1.7188v1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625-2.0469 1.6562-0.1875c0.039062 0.33594 0.14453 0.58594 0.3125 0.75 0.17578 0.15625 0.40625 0.23438 0.6875 0.23438 0.35156 0 0.64844-0.16016 0.89062-0.48438 0.25-0.32031 0.41016-0.98828 0.48438-2-0.4375 0.49219-0.97656 0.73438-1.6094 0.73438-0.71094 0-1.3203-0.26562-1.8281-0.79688-0.51172-0.53906-0.76562-1.2422-0.76562-2.1094 0-0.89453 0.26953-1.6172 0.8125-2.1719 0.53906-0.55078 1.2227-0.82812 2.0469-0.82812 0.90625 0 1.6484 0.35156 2.2344 1.0469 0.58203 0.69922 0.875 1.8438 0.875 3.4375 0 1.6172-0.30469 2.7812-0.90625 3.5-0.60547 0.71875-1.3906 1.0781-2.3594 1.0781-0.69922 0-1.2656-0.17969-1.7031-0.54688-0.42969-0.375-0.70312-0.92578-0.82812-1.6562zm3.875-3.7188c0-0.55078-0.13281-0.97656-0.39062-1.2812-0.25-0.30078-0.54297-0.45312-0.875-0.45312-0.3125 0-0.57422 0.125-0.78125 0.375-0.21094 0.25-0.3125 0.65625-0.3125 1.2188 0 0.57422 0.11328 0.99609 0.34375 1.2656 0.22656 0.27344 0.50781 0.40625 0.84375 0.40625 0.33203 0 0.60938-0.12891 0.82812-0.39062 0.22656-0.25781 0.34375-0.64062 0.34375-1.1406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2-4.7812c-0.44922-0.1875-0.77344-0.44141-0.96875-0.76562-0.19922-0.32031-0.29688-0.67969-0.29688-1.0781 0-0.65625 0.22656-1.1953 0.6875-1.625 0.46875-0.4375 1.1289-0.65625 1.9844-0.65625 0.85156 0 1.5156 0.21875 1.9844 0.65625 0.46875 0.42969 0.70312 0.96875 0.70312 1.625 0 0.41797-0.10938 0.78906-0.32812 1.1094-0.21875 0.3125-0.52344 0.55859-0.90625 0.73438 0.48828 0.19922 0.86328 0.48438 1.125 0.85938 0.25781 0.375 0.39062 0.8125 0.39062 1.3125 0 0.82422-0.26562 1.4922-0.79688 2-0.52344 0.51172-1.2188 0.76562-2.0938 0.76562-0.8125 0-1.4844-0.21094-2.0156-0.64062-0.64844-0.5-0.96875-1.1797-0.96875-2.0469 0-0.47656 0.11719-0.91406 0.35938-1.3125 0.23828-0.40625 0.61719-0.71875 1.1406-0.9375zm0.34375-1.7188c0 0.34375 0.09375 0.60938 0.28125 0.79688 0.19531 0.1875 0.45703 0.28125 0.78125 0.28125 0.32031 0 0.58203-0.09375 0.78125-0.28125 0.19531-0.19531 0.29688-0.46094 0.29688-0.79688 0-0.32031-0.10156-0.57812-0.29688-0.76562-0.1875-0.19531-0.44531-0.29688-0.76562-0.29688-0.32422 0-0.58594 0.10156-0.78125 0.29688-0.19922 0.19922-0.29688 0.45312-0.29688 0.76562zm-0.15625 3.7969c0 0.46875 0.11719 0.83984 0.35938 1.1094 0.25 0.26172 0.55078 0.39062 0.90625 0.39062 0.35156 0 0.64453-0.125 0.875-0.375 0.23828-0.25781 0.35938-0.62891 0.35938-1.1094 0-0.40625-0.12109-0.73438-0.35938-0.98438-0.24219-0.25781-0.53906-0.39062-0.89062-0.39062-0.41797 0-0.73047 0.14844-0.9375 0.4375-0.21094 0.28125-0.3125 0.58984-0.3125 0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.54688-2.2812 1.7188-0.17188c0.039063 0.38672 0.17969 0.69531 0.42188 0.92188 0.23828 0.21875 0.51562 0.32812 0.82812 0.32812 0.36328 0 0.66406-0.14453 0.90625-0.4375 0.25-0.28906 0.375-0.72656 0.375-1.3125 0-0.53906-0.125-0.94531-0.375-1.2188-0.24219-0.26953-0.55859-0.40625-0.95312-0.40625-0.49219 0-0.92969 0.21484-1.3125 0.64062l-1.3906-0.1875 0.875-4.625h4.5156v1.5938h-3.2188l-0.26562 1.5c0.375-0.1875 0.75781-0.28125 1.1562-0.28125 0.75781 0 1.4062 0.27734 1.9375 0.82812 0.53125 0.54297 0.79688 1.25 0.79688 2.125 0 0.74219-0.21484 1.3984-0.64062 1.9688-0.58594 0.78125-1.3906 1.1719-2.4219 1.1719-0.82422 0-1.4961-0.21875-2.0156-0.65625-0.52344-0.44531-0.83594-1.0391-0.9375-1.7812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.89062-7.2969v-1.5781h1.7188v1.5781zm0 7.2969v-6.4219h1.7188v6.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-25-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.7812 0h-1.7188v-3.2812c0-0.6875-0.039062-1.1328-0.10938-1.3438-0.074219-0.20703-0.19531-0.36328-0.35938-0.46875-0.15625-0.11328-0.35547-0.17188-0.59375-0.17188-0.29297 0-0.55859 0.085937-0.79688 0.25-0.23047 0.15625-0.39062 0.37109-0.48438 0.64062-0.085938 0.26172-0.125 0.75-0.125 1.4688v2.9062h-1.7188v-6.4219h1.5938v0.9375c0.5625-0.72656 1.2734-1.0938 2.1406-1.0938 0.375 0 0.71875 0.070313 1.0312 0.20312 0.3125 0.13672 0.54688 0.3125 0.70312 0.53125 0.16406 0.21094 0.28125 0.44922 0.34375 0.71875 0.0625 0.26172 0.09375 0.63672 0.09375 1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-26-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.375-3.1719c0-0.75781 0.078125-1.3672 0.23438-1.8281 0.15625-0.45703 0.39062-0.8125 0.70312-1.0625 0.3125-0.25781 0.70312-0.39062 1.1719-0.39062 0.34375 0 0.64453 0.074219 0.90625 0.21875 0.25781 0.13672 0.47266 0.33594 0.64062 0.59375 0.17578 0.26172 0.3125 0.57812 0.40625 0.95312s0.14062 0.88281 0.14062 1.5156c0 0.76172-0.078125 1.375-0.23438 1.8438-0.15625 0.46094-0.39062 0.8125-0.70312 1.0625-0.30469 0.25-0.6875 0.375-1.1562 0.375-0.625 0-1.1172-0.22266-1.4688-0.67188-0.42969-0.53125-0.64062-1.3984-0.64062-2.6094zm0.8125 0c0 1.0625 0.125 1.7734 0.375 2.125 0.25 0.34375 0.55469 0.51562 0.92188 0.51562 0.36328 0 0.66406-0.17578 0.90625-0.53125 0.25-0.35156 0.375-1.0547 0.375-2.1094 0-1.0508-0.125-1.75-0.375-2.0938-0.24219-0.35156-0.54688-0.53125-0.92188-0.53125-0.36719 0-0.65625 0.15625-0.875 0.46875-0.27344 0.38672-0.40625 1.1055-0.40625 2.1562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-27-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.42188-3.5781c0-0.86328 0.085937-1.5547 0.26562-2.0781 0.17578-0.51953 0.4375-0.92188 0.78125-1.2031 0.35156-0.28125 0.78906-0.42188 1.3125-0.42188 0.39453 0 0.73828 0.078125 1.0312 0.23438 0.28906 0.15625 0.53125 0.38281 0.71875 0.67188 0.19531 0.29297 0.34766 0.65234 0.45312 1.0781 0.11328 0.42969 0.17188 1 0.17188 1.7188 0 0.85547-0.089844 1.543-0.26562 2.0625-0.17969 0.52344-0.44531 0.92969-0.79688 1.2188-0.34375 0.28125-0.78125 0.42188-1.3125 0.42188-0.69922 0-1.2461-0.25-1.6406-0.75-0.48047-0.60156-0.71875-1.5859-0.71875-2.9531zm0.92188 0c0 1.1875 0.13281 1.9805 0.40625 2.375 0.28125 0.39844 0.625 0.59375 1.0312 0.59375 0.41406 0 0.75781-0.19531 1.0312-0.59375 0.28125-0.39453 0.42188-1.1875 0.42188-2.375 0-1.1953-0.14062-1.9883-0.42188-2.375-0.27344-0.39453-0.61719-0.59375-1.0312-0.59375-0.41797 0-0.74609 0.17188-0.98438 0.51562-0.30469 0.4375-0.45312 1.2578-0.45312 2.4531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-27-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1094 0.125-2.1094-7.5h0.71875l2.0938 7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.9062 0v-1.5469h-2.7969v-0.71875l2.9375-4.1719h0.65625v4.1719h0.875v0.71875h-0.875v1.5469zm0-2.2656v-2.9062l-2.0156 2.9062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.375-3.1719c0-0.75781 0.078125-1.375 0.23438-1.8438s0.38281-0.82812 0.6875-1.0781c0.3125-0.25 0.70312-0.375 1.1719-0.375 0.35156 0 0.66016 0.074219 0.92188 0.21875 0.25781 0.13672 0.47266 0.33594 0.64062 0.59375 0.16406 0.26172 0.29688 0.57812 0.39062 0.95312 0.10156 0.375 0.15625 0.88672 0.15625 1.5312 0 0.75-0.078125 1.3594-0.23438 1.8281-0.15625 0.46094-0.39062 0.82031-0.70312 1.0781-0.30469 0.25-0.69531 0.375-1.1719 0.375-0.61719 0-1.1016-0.22266-1.4531-0.67188-0.42969-0.53125-0.64062-1.3984-0.64062-2.6094zm0.8125 0c0 1.0547 0.11719 1.7578 0.35938 2.1094 0.25 0.34375 0.55469 0.51562 0.92188 0.51562 0.36328 0 0.67188-0.17188 0.92188-0.51562 0.25-0.35156 0.375-1.0547 0.375-2.1094 0-1.0625-0.125-1.7656-0.375-2.1094-0.25-0.35156-0.55859-0.53125-0.92188-0.53125-0.36719 0-0.65625 0.15234-0.875 0.45312-0.27344 0.39844-0.40625 1.125-0.40625 2.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 0v-4.6719h0.70312v0.65625c0.14453-0.22656 0.33594-0.41016 0.57812-0.54688 0.25-0.13281 0.53125-0.20312 0.84375-0.20312 0.34375 0 0.625 0.074219 0.84375 0.21875 0.21875 0.13672 0.375 0.33594 0.46875 0.59375 0.375-0.53906 0.85156-0.8125 1.4375-0.8125 0.46875 0 0.82812 0.13281 1.0781 0.39062 0.25 0.25 0.375 0.64062 0.375 1.1719v3.2031h-0.79688v-2.9375c0-0.32031-0.027344-0.55078-0.078125-0.6875-0.042969-0.13281-0.13281-0.24219-0.26562-0.32812-0.13672-0.09375-0.29688-0.14062-0.48438-0.14062-0.32422 0-0.59375 0.10938-0.8125 0.32812s-0.32812 0.57031-0.32812 1.0469v2.7188h-0.79688v-3.0312c0-0.35156-0.0625-0.61719-0.1875-0.79688-0.125-0.17578-0.33594-0.26562-0.625-0.26562-0.23047 0-0.4375 0.0625-0.625 0.1875-0.1875 0.11719-0.32422 0.28906-0.40625 0.51562-0.085937 0.21875-0.125 0.54297-0.125 0.96875v2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4844-4.8594-0.79688 0.0625c-0.0625-0.3125-0.16406-0.53906-0.29688-0.6875-0.21094-0.21875-0.46875-0.32812-0.78125-0.32812-0.26172 0-0.48438 0.070312-0.67188 0.20312-0.25 0.1875-0.44922 0.45312-0.59375 0.79688-0.13672 0.34375-0.21094 0.83984-0.21875 1.4844 0.1875-0.28125 0.41406-0.48828 0.6875-0.625 0.28125-0.14453 0.57031-0.21875 0.875-0.21875 0.53125 0 0.97656 0.19531 1.3438 0.57812 0.375 0.38672 0.5625 0.88672 0.5625 1.5 0 0.40625-0.089844 0.78906-0.26562 1.1406-0.17969 0.34375-0.41797 0.60938-0.71875 0.79688-0.30469 0.17578-0.64844 0.26562-1.0312 0.26562-0.65625 0-1.1953-0.23828-1.6094-0.71875-0.41797-0.48828-0.625-1.2891-0.625-2.4062 0-1.2383 0.22656-2.1445 0.6875-2.7188 0.39453-0.48828 0.9375-0.73438 1.625-0.73438 0.5 0 0.91016 0.14844 1.2344 0.4375 0.32031 0.28125 0.51953 0.67188 0.59375 1.1719zm-3.2344 2.7656c0 0.28125 0.054688 0.54688 0.17188 0.79688 0.11328 0.24219 0.27344 0.42969 0.48438 0.5625 0.20703 0.125 0.42578 0.1875 0.65625 0.1875 0.33203 0 0.61719-0.12891 0.85938-0.39062 0.23828-0.26953 0.35938-0.64062 0.35938-1.1094 0-0.44531-0.12109-0.79688-0.35938-1.0469-0.23047-0.25781-0.52734-0.39062-0.89062-0.39062-0.35547 0-0.65625 0.13281-0.90625 0.39062-0.25 0.25-0.375 0.58594-0.375 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.45312 0.39062 0.76562 0.10938c0.03125 0.23828 0.11719 0.41016 0.26562 0.51562 0.19531 0.14453 0.46875 0.21875 0.8125 0.21875 0.36328 0 0.64453-0.074219 0.84375-0.21875 0.19531-0.14844 0.33203-0.35156 0.40625-0.60938 0.039063-0.16797 0.054687-0.50391 0.046875-1.0156-0.34375 0.40625-0.77344 0.60938-1.2812 0.60938-0.64844 0-1.1484-0.22656-1.5-0.6875-0.34375-0.46875-0.51562-1.0234-0.51562-1.6719 0-0.44531 0.078125-0.85938 0.23438-1.2344 0.16406-0.375 0.39844-0.66016 0.70312-0.85938 0.30078-0.20703 0.66016-0.3125 1.0781-0.3125 0.55078 0 1.0039 0.21875 1.3594 0.65625v-0.5625h0.73438v4.0312c0 0.72656-0.078125 1.2422-0.23438 1.5469-0.14844 0.30078-0.38281 0.53906-0.70312 0.71875-0.3125 0.17578-0.70312 0.26562-1.1719 0.26562-0.5625 0-1.0156-0.125-1.3594-0.375-0.33594-0.25-0.49609-0.625-0.48438-1.125zm0.65625-2.8125c0 0.61719 0.11719 1.0625 0.35938 1.3438 0.23828 0.28125 0.53906 0.42188 0.90625 0.42188 0.36328 0 0.67188-0.14062 0.92188-0.42188s0.375-0.71875 0.375-1.3125c0-0.57031-0.13281-1.0039-0.39062-1.2969-0.25-0.28906-0.55469-0.4375-0.90625-0.4375-0.35547 0-0.65625 0.14844-0.90625 0.4375-0.24219 0.28125-0.35938 0.70312-0.35938 1.2656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.10938 1.875-6.6562h0.625l-1.8594 6.6562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-28-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.10938-3.2188c0.019531-0.16406 0.085937-0.33203 0.20312-0.5 0.1875-0.25 0.48828-0.52344 0.90625-0.82812 0.42578-0.3125 0.67969-0.51562 0.76562-0.60938 0.10156-0.11328 0.15625-0.23438 0.15625-0.35938 0-0.14453-0.054687-0.25781-0.15625-0.34375-0.10547-0.09375-0.25781-0.14062-0.45312-0.14062-0.1875 0-0.33594 0.039062-0.4375 0.10938-0.09375 0.0625-0.17188 0.19531-0.23438 0.39062l-0.65625-0.078125c0.082031-0.32031 0.22656-0.55469 0.4375-0.70312 0.20703-0.15625 0.50781-0.23438 0.90625-0.23438 0.4375 0 0.75781 0.089844 0.96875 0.26562 0.20703 0.16797 0.3125 0.375 0.3125 0.625 0 0.24219-0.085937 0.46875-0.25 0.6875-0.13672 0.16797-0.4375 0.42188-0.90625 0.76562-0.24219 0.17969-0.41406 0.32031-0.51562 0.42188h1.6875v0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.10938h-0.48438l-2.5469-2.0312c-0.17578-0.13281-0.33203-0.26953-0.46875-0.40625v2.2031h-0.46875v-2.8281h0.46875l2.75 2.2188 0.28125 0.23438v-2.5156h0.46875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.015625-3.9688-1.5312v-0.5625l3.9688-1.6094v0.59375l-1.2031 0.46875v1.6406l1.2031 0.4375zm-1.625-1.1406v-1.3438l-1.1094 0.40625c-0.33203 0.125-0.60156 0.21875-0.8125 0.28125 0.25 0.054688 0.5 0.125 0.75 0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.4375h-3.9688v-1.75c0-0.35156 0.039062-0.61719 0.10938-0.79688 0.074219-0.1875 0.19922-0.33203 0.375-0.4375 0.17969-0.11328 0.375-0.17188 0.59375-0.17188 0.28125 0 0.52344 0.09375 0.71875 0.28125 0.1875 0.17969 0.30859 0.45312 0.35938 0.82812 0.074219-0.13281 0.14062-0.23828 0.20312-0.3125 0.14844-0.14453 0.32422-0.28516 0.53125-0.42188l1.0781-0.6875v0.65625l-0.82812 0.51562c-0.23828 0.15625-0.42188 0.28906-0.54688 0.39062-0.125 0.09375-0.21094 0.18359-0.26562 0.26562-0.050781 0.074219-0.085937 0.14844-0.10938 0.21875-0.00781 0.0625-0.015625 0.16406-0.015625 0.29688v0.60938h1.7656zm-2.2188-0.51562v-1.125c0-0.23828-0.019531-0.42578-0.0625-0.5625-0.050781-0.13281-0.12891-0.23438-0.23438-0.29688-0.11328-0.070312-0.23828-0.10938-0.375-0.10938-0.1875 0-0.33594 0.070313-0.45312 0.20312-0.125 0.13672-0.1875 0.35156-0.1875 0.64062v1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.4375h-3.9688v-0.53125h1.625v-2.0469h-1.625v-0.51562h3.9688v0.51562h-1.875v2.0469h1.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.9375-0.26562c-0.65625 0-1.1719-0.17578-1.5469-0.53125-0.375-0.35156-0.5625-0.80469-0.5625-1.3594 0-0.36328 0.089844-0.69141 0.26562-0.98438 0.17969-0.28906 0.42188-0.51562 0.73438-0.67188s0.66797-0.23438 1.0625-0.23438c0.40625 0 0.77344 0.085937 1.0938 0.25 0.3125 0.15625 0.55469 0.38672 0.71875 0.6875 0.15625 0.29297 0.23438 0.60938 0.23438 0.95312 0 0.375-0.085938 0.71094-0.26562 1-0.17578 0.29297-0.42188 0.51562-0.73438 0.67188-0.3125 0.14844-0.64453 0.21875-1 0.21875zm0.015625-0.54688c0.48047 0 0.85938-0.125 1.1406-0.375 0.27344-0.25781 0.40625-0.58203 0.40625-0.96875 0-0.38281-0.14062-0.70312-0.42188-0.95312-0.28125-0.25781-0.67578-0.39062-1.1875-0.39062-0.32031 0-0.60156 0.058594-0.84375 0.17188-0.23828 0.10547-0.42578 0.26172-0.5625 0.46875-0.13281 0.21094-0.20312 0.44531-0.20312 0.70312 0 0.36719 0.13281 0.68359 0.39062 0.95312 0.25 0.26172 0.67969 0.39062 1.2812 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.40625h-3.9688v-0.79688l2.8125-0.92188c0.26172-0.09375 0.45312-0.15625 0.57812-0.1875-0.13281-0.050781-0.34375-0.125-0.625-0.21875l-2.7656-0.9375v-0.70312h3.9688v0.5h-3.3281l3.3281 1.1406v0.46875l-3.375 1.1562h3.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.4375h-3.9688v-2.8594h0.46875v2.3438h1.2188v-2.1875h0.46875v2.1875h1.3438v-2.4219h0.46875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2812-0.25-0.03125-0.48438c0.19922-0.03125 0.35938-0.085937 0.48438-0.17188 0.125-0.082031 0.23047-0.21094 0.3125-0.39062 0.074219-0.17578 0.10938-0.37891 0.10938-0.60938 0-0.19531-0.023438-0.36719-0.078125-0.51562-0.0625-0.15625-0.14453-0.26953-0.25-0.34375-0.10156-0.082031-0.21875-0.125-0.34375-0.125s-0.23438 0.039063-0.32812 0.10938c-0.09375 0.074219-0.17188 0.19531-0.23438 0.35938-0.039063 0.10547-0.10156 0.33984-0.1875 0.70312-0.09375 0.36719-0.17578 0.62109-0.25 0.76562-0.10156 0.1875-0.22656 0.32812-0.375 0.42188-0.14453 0.085938-0.30469 0.125-0.48438 0.125-0.20703 0-0.39453-0.050781-0.5625-0.15625-0.17578-0.11328-0.30469-0.28125-0.39062-0.5-0.09375-0.21875-0.14062-0.45703-0.14062-0.71875 0-0.30078 0.046875-0.5625 0.14062-0.78125s0.23438-0.39062 0.42188-0.51562c0.17969-0.125 0.38281-0.1875 0.60938-0.1875l0.046875 0.5c-0.25 0.023437-0.4375 0.10938-0.5625 0.26562-0.13281 0.15625-0.20312 0.38672-0.20312 0.6875 0 0.32422 0.0625 0.55859 0.1875 0.70312 0.11719 0.13672 0.25 0.20312 0.40625 0.20312 0.14844 0 0.26562-0.050781 0.35938-0.15625 0.09375-0.09375 0.1875-0.35156 0.28125-0.78125 0.09375-0.42578 0.17969-0.71875 0.25-0.875 0.10547-0.22656 0.24219-0.39453 0.40625-0.5 0.16797-0.11328 0.35547-0.17188 0.5625-0.17188 0.21875 0 0.42188 0.0625 0.60938 0.1875 0.17969 0.11719 0.32031 0.28906 0.42188 0.51562 0.10156 0.21875 0.15625 0.46875 0.15625 0.75 0 0.36719-0.054688 0.66797-0.15625 0.90625-0.10156 0.24219-0.25781 0.42969-0.46875 0.5625-0.20703 0.13672-0.44531 0.21094-0.71875 0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.42188h-3.9688v-1.5c0-0.25781 0.011719-0.45703 0.03125-0.59375 0.03125-0.19531 0.09375-0.35938 0.1875-0.48438 0.09375-0.13281 0.22656-0.23828 0.39062-0.3125 0.15625-0.082031 0.33594-0.125 0.53125-0.125 0.34375 0 0.63672 0.10938 0.875 0.32812 0.23047 0.21094 0.34375 0.59375 0.34375 1.1562v1h1.6094zm-2.0781-0.53125v-1.0156c0-0.33203-0.0625-0.57031-0.1875-0.71875-0.13281-0.14453-0.31641-0.21875-0.54688-0.21875-0.16406 0-0.30469 0.042969-0.42188 0.125-0.11328 0.085938-0.19141 0.19531-0.23438 0.32812-0.019531 0.09375-0.03125 0.26172-0.03125 0.5v1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.42188h-3.9688v-0.53125l3.1094-2.0781h-3.1094v-0.5h3.9688v0.53125l-3.125 2.0781h3.125zm-4.2031-0.73438c-0.1875 0-0.33594-0.050781-0.45312-0.15625-0.11328-0.10156-0.17188-0.23438-0.17188-0.39062 0-0.11328 0.054687-0.26562 0.15625-0.45312 0.054687-0.10156 0.078125-0.19141 0.078125-0.26562 0-0.050781-0.015625-0.09375-0.046875-0.125s-0.09375-0.050781-0.1875-0.0625v-0.35938c0.19922 0.011719 0.35156 0.070312 0.45312 0.17188 0.10547 0.09375 0.15625 0.21484 0.15625 0.35938 0 0.11719-0.050781 0.26562-0.15625 0.45312-0.0625 0.11719-0.09375 0.20312-0.09375 0.26562s0.023438 0.10938 0.0625 0.14062c0.054688 0.042969 0.12109 0.0625 0.20312 0.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.48438h-0.5625v-0.5625h0.5625c0.20703 0 0.375 0.039063 0.5 0.10938 0.125 0.074219 0.21875 0.1875 0.28125 0.34375l-0.20312 0.14062c-0.042969-0.10156-0.10938-0.17578-0.20312-0.21875-0.085938-0.050781-0.21094-0.082031-0.375-0.09375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-29-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.5h-0.5625v-0.54688h0.5625z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m207.63 76.18-5.1758-6.168 4.5664-3.832 0.87109 1.043-3.3164 2.7852 1.1523 1.3672 3.082-2.5859 0.875 1.043-3.082 2.5859 1.4024 1.6719 3.4336-2.8867 0.875 1.043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.41 63.34 1.25-1.0469 3.2774 3.9062c0.42968 0.51172 0.71484 0.94532 0.85547 1.293 0.18359 0.46094 0.20703 0.9336 0.0703 1.418-0.13281 0.48438-0.46094 0.94141-0.98047 1.3789-0.60938 0.50781-1.2148 0.73047-1.832 0.66797-0.61328-0.0664-1.1992-0.42579-1.75-1.082l1.0625-1.1289c0.30859 0.33984 0.57031 0.54687 0.78125 0.61719 0.3164 0.10937 0.61328 0.0508 0.88672-0.17969 0.27343-0.23047 0.40234-0.47266 0.38281-0.72656-0.0195-0.25391-0.23828-0.62891-0.66016-1.1289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.16 67.344-5.1758-6.168 4.5664-3.832 0.875 1.043-3.3164 2.7812 1.1484 1.3711 3.082-2.5898 0.875 1.043-3.082 2.5898 1.4024 1.668 3.4336-2.8828 0.875 1.043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.88 62.543-5.1758-6.168 1.8711-1.5703 4.6367 3.2812-2.4375-5.125 1.875-1.5742 5.1719 6.168-1.1523 0.96875-4.0781-4.8516 2.8555 5.875-1.1953 1.0078-5.2852-3.8359 4.0703 4.8555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.03 50.329 1.4766 1.7539 0.67968-0.56641c0.48828-0.41016 0.78907-0.71875 0.89844-0.92188 0.10938-0.20312 0.15234-0.41406 0.13281-0.6289-0.0234-0.21875-0.10937-0.41406-0.26172-0.59766-0.1914-0.22656-0.41406-0.35547-0.66796-0.39453-0.25391-0.0352-0.4961 0.0117-0.73047 0.14453-0.16797 0.0937-0.47657 0.33203-0.92578 0.70703zm3.0547 6.1719-5.1758-6.168 1.9961-1.6758c0.75782-0.63281 1.2734-1.0156 1.5586-1.1484 0.42968-0.20313 0.89453-0.25 1.3906-0.14063 0.5 0.10938 0.95313 0.41016 1.3672 0.90235 0.31641 0.3789 0.51562 0.7539 0.59375 1.1289 0.082 0.3711 0.0781 0.71875-0.0117 1.0469-0.0859 0.32422-0.21875 0.60156-0.39844 0.83203-0.24609 0.30859-0.65234 0.69531-1.2148 1.168l-0.80859 0.67968 1.9492 2.3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.86 51.657-5.1328-6.1133 1.25-1.0508 4.2578 5.0742 3.0938-2.5938 0.8711 1.043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.52 43.321c0.58985 0.69922 1.1953 1.0938 1.8203 1.1836 0.6289 0.0898 1.1875-0.0742 1.6875-0.49219 0.49609-0.41797 0.7539-0.9375 0.77343-1.5664 0.0195-0.625-0.27343-1.2969-0.875-2.0117-0.59375-0.70703-1.1914-1.1055-1.793-1.1914-0.60547-0.0898-1.1641 0.082-1.6758 0.51563-0.51562 0.42968-0.78125 0.95312-0.80078 1.5703-0.0195 0.61719 0.26953 1.2812 0.86328 1.9922m-1.2461 1.1172c-0.52734-0.6289-0.87891-1.2344-1.0508-1.8203-0.12109-0.43359-0.16797-0.875-0.13281-1.3281 0.0312-0.45703 0.14062-0.86328 0.32812-1.2266 0.25-0.48828 0.625-0.9414 1.125-1.3594 0.91016-0.76172 1.875-1.0898 2.8945-0.99219 1.0195 0.10938 1.9531 0.67188 2.7969 1.6758 0.83984 0.9961 1.2226 2.0039 1.1523 3.0234-0.0664 1.0195-0.55469 1.9062-1.4609 2.668-0.91796 0.76953-1.8828 1.1016-2.8945 0.99609-1.0156-0.10547-1.9336-0.65234-2.7578-1.6367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.61 40.293-3.8164-7.6602 0.88672-0.75 3.8047 7.6719z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.95 35.641-5.1758-6.168 4.5664-3.832 0.875 1.043-3.3203 2.7773 1.1524 1.3711 3.082-2.5898 0.875 1.0508-3.082 2.5781 1.4023 1.6797 3.4375-2.8906 0.8711 1.043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.06 31.352-0.57032-5.0078-4.4062-1.332 1.457-1.2188 2.7539 0.82032-0.32422-2.8633 1.4531-1.2188 0.54687 4.582 4.8203 1.4297-1.4961 1.2578-3.1172-0.94922 0.38282 3.2422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.64 20.821-2.7695-1.5703 1.082 2.9805zm4.3359 0.53125-1.3438 1.1289-1.7109-0.95703-2.4766 2.0781 0.66796 1.832-1.3203 1.1094-2.7812-8.1797 1.3203-1.1133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.63 20.801-5.1758-6.168 1.8711-1.5703 4.6367 3.2812-2.4375-5.1211 1.875-1.582 5.1758 6.1719-1.1562 0.96875-4.0781-4.8476 2.8594 5.8789-1.1992 1-5.2852-3.8398 4.0664 4.8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.78 8.5824 1.4727 1.7617 0.67969-0.57031c0.48828-0.41015 0.78906-0.72265 0.89843-0.92187 0.10938-0.19922 0.15625-0.41016 0.13282-0.62891-0.0234-0.21094-0.10938-0.41016-0.26563-0.60156-0.1875-0.21875-0.41015-0.34766-0.66015-0.39063-0.25782-0.0391-0.5 0.0117-0.73438 0.14063-0.16797 0.10156-0.48047 0.33984-0.92578 0.71094zm3.0508 6.1797-5.1758-6.168 1.9961-1.6836c0.75781-0.62891 1.2773-1.0078 1.5586-1.1367 0.42969-0.21094 0.89453-0.26172 1.3906-0.15234 0.5 0.10937 0.95312 0.42187 1.3672 0.91015 0.32032 0.3711 0.51563 0.75 0.59375 1.1211 0.082 0.3789 0.0781 0.73047-0.0117 1.0508-0.0859 0.32031-0.21875 0.59766-0.39843 0.82812-0.2461 0.3125-0.65235 0.69922-1.2148 1.1719l-0.80859 0.67969 1.9531 2.3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.6 9.9105-5.1328-6.1094 1.25-1.0508 4.2578 5.0703 3.0938-2.5898 0.875 1.043"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.14098 71.008h340.16v-70.867h-340.16z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.282
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264.09 -151.33)",
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("use", {
    x: 298.47601,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.56873,
    y: 160.96001,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.54257,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.17505,
    y: 160.96001,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.05258,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.20004,
    y: 160.96001,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.74008,
    y: 160.96001,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.61758,
    y: 160.96001,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.35886,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.9025,
    y: 160.96001,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.78003,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.92749,
    y: 160.96001,
    xlinkHref: "#glyph-22-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.14999,
    y: 160.96001,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.0275,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.66,
    y: 160.96001,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.20001,
    y: 160.96001,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 349.07751,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.70999,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 352.85748,
    y: 160.96001,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 356.73502,
    y: 160.96001,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.61252,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.76001,
    y: 160.96001,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 364.95502,
    y: 160.96001,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.495,
    y: 160.96001,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.03503,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 374.22955,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 377.77319,
    y: 160.96001,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 381.5426,
    y: 160.96001,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.73761,
    y: 160.96001,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 388.27762,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.42511,
    y: 160.96001,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 392.96512,
    y: 160.96001,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 397.18759,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 399.3815,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 404.07251,
    y: 160.96001,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.95001,
    y: 160.96001,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 412.17252,
    y: 160.96001,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.05002,
    y: 160.96001,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 419.92752,
    y: 160.96001,
    xlinkHref: "#glyph-22-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 423.80136,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 429.97668,
    y: 160.96001,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 433.85419,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 435.00168,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 436.14899,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 437.29651,
    y: 160.96001,
    xlinkHref: "#glyph-22-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 439.81119,
    y: 160.96001,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 442.00632,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 445.54999,
    y: 160.96001,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 447.03497,
    y: 160.96001,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 449.89249,
    y: 160.96001,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 452.74994,
    y: 160.96001,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 455.60742,
    y: 160.96001,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.46487,
    y: 160.96001,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 461.32239,
    y: 160.96001,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 464.17987,
    y: 160.96001,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 467.03732,
    y: 160.96001,
    xlinkHref: "#glyph-22-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.38,
    y: 160.96001,
    xlinkHref: "#glyph-22-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 474.19312,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 477.73679,
    y: 160.96001,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 481.27679,
    y: 160.96001,
    xlinkHref: "#glyph-22-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 485.15433,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 486.30179,
    y: 160.96001,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 490.52429,
    y: 160.96001,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 495.88678,
    y: 160.96001,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 498.74429,
    y: 160.96001,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 502.9668,
    y: 160.96001,
    xlinkHref: "#glyph-22-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 507.18924,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 508.33673,
    y: 160.96001,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 511.87674,
    y: 160.96001,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 515.07172,
    y: 160.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.21924,
    y: 160.96001,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 520.09674,
    y: 160.96001,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 525.12177,
    y: 160.96001,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 527.97925,
    y: 160.96001,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.83667,
    y: 160.96001,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.19922,
    y: 160.96001,
    xlinkHref: "#glyph-22-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 539.3905,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.9342,
    y: 160.96001,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.80804,
    y: 160.96001,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.49854,
    y: 160.96001,
    xlinkHref: "#glyph-22-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 555.37604,
    y: 160.96001,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.59851,
    y: 160.96001,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.15851,
    y: 160.96001,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.47913,
    y: 167.95766,
    xlinkHref: "#glyph-22-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 302.01913,
    y: 167.95766,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.89301,
    y: 167.95766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.43665,
    y: 167.95766,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.97668,
    y: 167.95766,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 314.12415,
    y: 167.95766,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.78653,
    y: 167.95766,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.46387,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 326.64511,
    y: 167.95766,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.50262,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.68762,
    y: 167.95766,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336.09158,
    y: 167.95766,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.19626,
    y: 167.95766,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.0701,
    y: 167.95766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 349.31308,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.49808,
    y: 167.95766,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.37558,
    y: 167.95766,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.25308,
    y: 167.95766,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 364.79309,
    y: 167.95766,
    xlinkHref: "#glyph-22-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.3056,
    y: 167.95766,
    xlinkHref: "#glyph-22-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.45306,
    y: 167.95766,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.31061,
    y: 167.95766,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 374.16809,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.31558,
    y: 167.95766,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.1731,
    y: 167.95766,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 381.03061,
    y: 167.95766,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 383.88809,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 385.03561,
    y: 167.95766,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 387.8931,
    y: 167.95766,
    xlinkHref: "#glyph-22-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.75061,
    y: 167.95766,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 393.60809,
    y: 167.95766,
    xlinkHref: "#glyph-22-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 394.75562,
    y: 167.95766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 397.6131,
    y: 167.95766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.47061,
    y: 167.95766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 403.32809,
    y: 167.95766,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 406.18564,
    y: 167.95766,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.67059,
    y: 167.95766,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 410.52811,
    y: 167.95766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.41934,
    y: 167.95766,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 420.97934,
    y: 167.95766,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 425.20184,
    y: 167.95766,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 429.07568,
    y: 167.95766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 435.31857,
    y: 167.95766,
    xlinkHref: "#glyph-22-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 439.19604,
    y: 167.95766,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 443.41855,
    y: 167.95766,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 447.97855,
    y: 167.95766,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 454.55215,
    y: 167.95766,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.09216,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 459.23599,
    y: 167.95766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 462.77966,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 463.92715,
    y: 167.95766,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 467.46716,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.65216,
    y: 167.95766,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 475.19214,
    y: 167.95766,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.33966,
    y: 167.95766,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.25464,
    y: 167.95766,
    xlinkHref: "#glyph-22-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 486.11227,
    y: 167.95766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 488.9697,
    y: 167.95766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.82721,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 492.9747,
    y: 167.95766,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 495.83215,
    y: 167.95766,
    xlinkHref: "#glyph-22-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 498.68967,
    y: 167.95766,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 501.54715,
    y: 167.95766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 502.69461,
    y: 167.95766,
    xlinkHref: "#glyph-22-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 505.55212,
    y: 167.95766,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 508.40961,
    y: 167.95766,
    xlinkHref: "#glyph-22-36"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264.09 -151.33)",
    fill: "#131012"
  }, /*#__PURE__*/React.createElement("use", {
    x: 511.26801,
    y: 167.96001,
    xlinkHref: "#glyph-23-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 518.20551,
    y: 167.96001,
    xlinkHref: "#glyph-23-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 525.14301,
    y: 167.96001,
    xlinkHref: "#glyph-23-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 532.08051,
    y: 167.96001,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 533.22803,
    y: 167.96001,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.42297,
    y: 167.96001,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 539.96289,
    y: 167.96001,
    xlinkHref: "#glyph-23-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.90039,
    y: 167.96001,
    xlinkHref: "#glyph-23-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.83789,
    y: 167.96001,
    xlinkHref: "#glyph-23-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 560.77539,
    y: 167.96001,
    xlinkHref: "#glyph-23-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.47992,
    y: 174.95728,
    xlinkHref: "#glyph-22-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.9649,
    y: 174.95728,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 302.82242,
    y: 174.95728,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.67993,
    y: 174.95728,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.53741,
    y: 174.95728,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.39493,
    y: 174.95728,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.87991,
    y: 174.95728,
    xlinkHref: "#glyph-22-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.73743,
    y: 174.95728,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 318.59491,
    y: 174.95728,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 321.45245,
    y: 174.95728,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.93741,
    y: 174.95728,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.79492,
    y: 174.95728,
    xlinkHref: "#glyph-22-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.65244,
    y: 174.95728,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.50995,
    y: 174.95728,
    xlinkHref: "#glyph-22-40"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264.09 -151.33)",
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("use", {
    x: 335.01251,
    y: 174.95,
    xlinkHref: "#glyph-22-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 337.87,
    y: 174.95,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.7475,
    y: 174.95,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 347.64252,
    y: 174.95,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.50003,
    y: 174.95,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 353.35751,
    y: 174.95,
    xlinkHref: "#glyph-22-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 356.21503,
    y: 174.95,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 359.07251,
    y: 174.95,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.93005,
    y: 174.95,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.80505,
    y: 174.95,
    xlinkHref: "#glyph-22-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.9964,
    y: 174.95,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.54004,
    y: 174.95,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 377.41391,
    y: 174.95,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 382.63678,
    y: 174.95,
    xlinkHref: "#glyph-22-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 386.51428,
    y: 174.95,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.73679,
    y: 174.95,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.29675,
    y: 174.95,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.85428,
    y: 174.95,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 404.72812,
    y: 174.95,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408.27179,
    y: 174.95,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 412.14563,
    y: 174.95,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 415.68933,
    y: 174.95,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 419.56317,
    y: 174.95,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 424.78683,
    y: 174.95,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 425.93433,
    y: 174.95,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 429.81183,
    y: 174.95,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 433.68939,
    y: 174.95,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 436.8544,
    y: 174.95,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.72821,
    y: 174.95,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 445.95096,
    y: 174.95,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 448.80847,
    y: 174.95,
    xlinkHref: "#glyph-22-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 451.66595,
    y: 174.95,
    xlinkHref: "#glyph-22-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 454.52341,
    y: 174.95,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.38092,
    y: 174.95,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 460.23837,
    y: 174.95,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 463.40341,
    y: 174.95,
    xlinkHref: "#glyph-22-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 466.56799,
    y: 174.95,
    xlinkHref: "#glyph-24-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 473.50549,
    y: 174.95,
    xlinkHref: "#glyph-24-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480.44299,
    y: 174.95,
    xlinkHref: "#glyph-24-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.38049,
    y: 174.95,
    xlinkHref: "#glyph-24-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 494.31799,
    y: 174.95,
    xlinkHref: "#glyph-24-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 501.25549,
    y: 174.95,
    xlinkHref: "#glyph-24-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 508.19299,
    y: 174.95,
    xlinkHref: "#glyph-24-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 515.13049,
    y: 174.95,
    xlinkHref: "#glyph-24-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 524.05707,
    y: 174.95,
    xlinkHref: "#glyph-24-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.99457,
    y: 174.95,
    xlinkHref: "#glyph-24-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.93207,
    y: 174.95,
    xlinkHref: "#glyph-24-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.88715,
    y: 174.95,
    xlinkHref: "#glyph-24-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.82465,
    y: 174.95,
    xlinkHref: "#glyph-24-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 560.76215,
    y: 174.95,
    xlinkHref: "#glyph-24-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.48764,
    y: 181.94766,
    xlinkHref: "#glyph-24-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.42514,
    y: 181.94766,
    xlinkHref: "#glyph-24-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.36264,
    y: 181.94766,
    xlinkHref: "#glyph-24-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.30014,
    y: 181.94766,
    xlinkHref: "#glyph-24-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.56265,
    y: 181.94766,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 331.42014,
    y: 181.94766,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.82672,
    y: 181.94766,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 339.01773,
    y: 181.94766,
    xlinkHref: "#glyph-24-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.95523,
    y: 181.94766,
    xlinkHref: "#glyph-24-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 352.89273,
    y: 181.94766,
    xlinkHref: "#glyph-24-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 359.83023,
    y: 181.94766,
    xlinkHref: "#glyph-24-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 366.76773,
    y: 181.94766,
    xlinkHref: "#glyph-24-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.70523,
    y: 181.94766,
    xlinkHref: "#glyph-24-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 382.96774,
    y: 181.94766,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 385.82523,
    y: 181.94766,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 388.68259,
    y: 181.94766,
    xlinkHref: "#glyph-24-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 397.94507,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.80258,
    y: 181.94766,
    xlinkHref: "#glyph-22-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 403.6601,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 406.51761,
    y: 181.94766,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408.00259,
    y: 181.94766,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 410.86008,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 413.71759,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.57504,
    y: 181.94766,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 418.06003,
    y: 181.94766,
    xlinkHref: "#glyph-22-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 420.91754,
    y: 181.94766,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 423.77499,
    y: 181.94766,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 426.63248,
    y: 181.94766,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 429.48999,
    y: 181.94766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432.96243,
    y: 181.94766,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 436.84,
    y: 181.94766,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.71747,
    y: 181.94766,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 446.91998,
    y: 181.94766,
    xlinkHref: "#glyph-22-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 449.7775,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 452.63495,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 455.49243,
    y: 181.94766,
    xlinkHref: "#glyph-22-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.34988,
    y: 181.94766,
    xlinkHref: "#glyph-22-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 461.2074,
    y: 181.94766,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 464.06488,
    y: 181.94766,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 466.92233,
    y: 181.94766,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.77985,
    y: 181.94766,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.26483,
    y: 181.94766,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 474.12228,
    y: 181.94766,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 477.59949,
    y: 181.94766,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 482.15582,
    y: 181.94766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 485.69946,
    y: 181.94766,
    xlinkHref: "#glyph-22-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.18448,
    y: 181.94766,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.74081,
    y: 181.94766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 495.28448,
    y: 181.94766,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 499.16199,
    y: 181.94766,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 503.38446,
    y: 181.94766,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 509.58698,
    y: 181.94766,
    xlinkHref: "#glyph-22-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 513.0639,
    y: 181.94766,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.60394,
    y: 181.94766,
    xlinkHref: "#glyph-22-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 517.7514,
    y: 181.94766,
    xlinkHref: "#glyph-22-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 522.9339,
    y: 181.94766,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.70337,
    y: 181.94766,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 529.89838,
    y: 181.94766,
    xlinkHref: "#glyph-22-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.46588,
    y: 181.94766,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.02209,
    y: 181.94766,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.56573,
    y: 181.94766,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.44324,
    y: 181.94766,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.66577,
    y: 181.94766,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.8728,
    y: 181.94766,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.02026,
    y: 181.94766,
    xlinkHref: "#glyph-22-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.54022,
    y: 181.94766,
    xlinkHref: "#glyph-22-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.48709,
    y: 188.94493,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.34457,
    y: 188.94493,
    xlinkHref: "#glyph-22-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 304.20209,
    y: 188.94493,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.0596,
    y: 188.94493,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.91711,
    y: 188.94493,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.7746,
    y: 188.94493,
    xlinkHref: "#glyph-22-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 315.63211,
    y: 188.94493,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 318.48959,
    y: 188.94493,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 322.06714,
    y: 188.94493,
    xlinkHref: "#glyph-22-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 324.42963,
    y: 188.94493,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.57712,
    y: 188.94493,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.13712,
    y: 188.94493,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.67709,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 337.8996,
    y: 188.94493,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 341.66916,
    y: 188.94493,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 344.4104,
    y: 188.94493,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 347.95407,
    y: 188.94493,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.8316,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 357.2691,
    y: 188.94493,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.80911,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.03159,
    y: 188.94493,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 370.12411,
    y: 188.94493,
    xlinkHref: "#glyph-22-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.31546,
    y: 188.94493,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 376.85913,
    y: 188.94493,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 380.73297,
    y: 188.94493,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 385.15335,
    y: 188.94493,
    xlinkHref: "#glyph-22-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.03088,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 393.25336,
    y: 188.94493,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 397.81335,
    y: 188.94493,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 402.56839,
    y: 188.94493,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.12836,
    y: 188.94493,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 410.66837,
    y: 188.94493,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 414.2084,
    y: 188.94493,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 415.35587,
    y: 188.94493,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 419.23343,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 423.45587,
    y: 188.94493,
    xlinkHref: "#glyph-22-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 425.81836,
    y: 188.94493,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 429.35843,
    y: 188.94493,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 430.5022,
    y: 188.94493,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 434.04593,
    y: 188.94493,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 436.40842,
    y: 188.94493,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.28592,
    y: 188.94493,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 445.04108,
    y: 188.94493,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 448.91858,
    y: 188.94493,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.06607,
    y: 188.94493,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 453.04056,
    y: 188.94493,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 454.18805,
    y: 188.94493,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.72806,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 461.95056,
    y: 188.94493,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.82806,
    y: 188.94493,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 466.97556,
    y: 188.94493,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 470.51556,
    y: 188.94493,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 474.39304,
    y: 188.94493,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 477.58804,
    y: 188.94493,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 482.34305,
    y: 188.94493,
    xlinkHref: "#glyph-22-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 485.20056,
    y: 188.94493,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 488.05801,
    y: 188.94493,
    xlinkHref: "#glyph-22-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 492.13049,
    y: 188.94493,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 496.008,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 500.2305,
    y: 188.94493,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 502.59299,
    y: 188.94493,
    xlinkHref: "#glyph-22-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 505.4505,
    y: 188.94493,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 508.30795,
    y: 188.94493,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 512.38043,
    y: 188.94493,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.25793,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 520.48047,
    y: 188.94493,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 523.33795,
    y: 188.94493,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 527.56042,
    y: 188.94493,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 531.43793,
    y: 188.94493,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 532.58179,
    y: 188.94493,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.00391,
    y: 188.94493,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 538.15137,
    y: 188.94493,
    xlinkHref: "#glyph-22-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.02887,
    y: 188.94493,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.90637,
    y: 188.94493,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.78394,
    y: 188.94493,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.32391,
    y: 188.94493,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.51886,
    y: 188.94493,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 560.39642,
    y: 188.94493,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.54022,
    y: 188.94493,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.08392,
    y: 188.94493,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.48709,
    y: 195.9426,
    xlinkHref: "#glyph-22-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.57248,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.11615,
    y: 195.9426,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 307.97366,
    y: 195.9426,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 310.83118,
    y: 195.9426,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 314.37119,
    y: 195.9426,
    xlinkHref: "#glyph-22-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 316.88367,
    y: 195.9426,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 321.91312,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.45679,
    y: 195.9426,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 328.3143,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 332.18814,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.73181,
    y: 195.9426,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 338.58932,
    y: 195.9426,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.46683,
    y: 195.9426,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 343.61069,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 347.62332,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.16699,
    y: 195.9426,
    xlinkHref: "#glyph-22-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 354.362,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 358.23584,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 361.77951,
    y: 195.9426,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.31952,
    y: 195.9426,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 369.54199,
    y: 195.9426,
    xlinkHref: "#glyph-22-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 372.73703,
    y: 195.9426,
    xlinkHref: "#glyph-22-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.92838,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 379.47202,
    y: 195.9426,
    xlinkHref: "#glyph-22-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 382.32953,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 386.20706,
    y: 195.9426,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.42953,
    y: 195.9426,
    xlinkHref: "#glyph-22-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 392.72452,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 396.60202,
    y: 195.9426,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 397.74954,
    y: 195.9426,
    xlinkHref: "#glyph-22-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.50125,
    y: 195.9426,
    xlinkHref: "#glyph-22-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 402.79623,
    y: 195.9426,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.65372,
    y: 195.9426,
    xlinkHref: "#glyph-22-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408.51126,
    y: 195.9426,
    xlinkHref: "#glyph-22-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.36871,
    y: 195.9426,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 414.2262,
    y: 195.9426,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 417.08371,
    y: 195.9426,
    xlinkHref: "#glyph-22-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 419.37866,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 423.25616,
    y: 195.9426,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 424.40366,
    y: 195.9426,
    xlinkHref: "#glyph-22-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 428.28116,
    y: 195.9426,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432.15503,
    y: 195.9426,
    xlinkHref: "#glyph-22-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 435.6987,
    y: 195.9426,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.72369,
    y: 195.9426,
    xlinkHref: "#glyph-22-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 444.60107,
    y: 195.9426,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 449.28857,
    y: 195.9426,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 453.84857,
    y: 195.9426,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.38858,
    y: 195.9426,
    xlinkHref: "#glyph-22-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 460.92859,
    y: 195.9426,
    xlinkHref: "#glyph-22-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 462.07608,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.95358,
    y: 195.9426,
    xlinkHref: "#glyph-22-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 470.17609,
    y: 195.9426,
    xlinkHref: "#glyph-22-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 472.47107,
    y: 195.9426,
    xlinkHref: "#glyph-22-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.34857,
    y: 195.9426,
    xlinkHref: "#glyph-22-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 479.54352,
    y: 195.9426,
    xlinkHref: "#glyph-22-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 483.42108,
    y: 195.9426,
    xlinkHref: "#glyph-22-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 484.56854,
    y: 195.9426,
    xlinkHref: "#glyph-22-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.76352,
    y: 195.9426,
    xlinkHref: "#glyph-22-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.64102,
    y: 195.9426,
    xlinkHref: "#glyph-22-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 496.20102,
    y: 195.9426,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 499.05853,
    y: 195.9426,
    xlinkHref: "#glyph-22-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 501.91599,
    y: 195.9426,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504.77347,
    y: 195.9426,
    xlinkHref: "#glyph-22-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 507.63092,
    y: 195.9426,
    xlinkHref: "#glyph-22-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 510.48843,
    y: 195.9426,
    xlinkHref: "#glyph-22-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 513.34595,
    y: 195.9426,
    xlinkHref: "#glyph-22-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.88593,
    y: 195.9426,
    xlinkHref: "#glyph-22-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 520.42596,
    y: 195.9426,
    xlinkHref: "#glyph-22-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 417.60199,
    y: 219.198,
    xlinkHref: "#glyph-25-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 424.53079,
    y: 219.198,
    xlinkHref: "#glyph-25-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 431.45956,
    y: 219.198,
    xlinkHref: "#glyph-25-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 438.38837,
    y: 219.198,
    xlinkHref: "#glyph-25-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 445.31714,
    y: 219.198,
    xlinkHref: "#glyph-25-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 452.24594,
    y: 219.198,
    xlinkHref: "#glyph-25-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 455.71033,
    y: 219.198,
    xlinkHref: "#glyph-25-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 462.63913,
    y: 219.198,
    xlinkHref: "#glyph-25-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 481.86777,
    y: 219.198,
    xlinkHref: "#glyph-25-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 488.79654,
    y: 219.198,
    xlinkHref: "#glyph-25-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 495.72534,
    y: 219.198,
    xlinkHref: "#glyph-25-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 499.18973,
    y: 219.198,
    xlinkHref: "#glyph-25-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 506.11853,
    y: 219.198,
    xlinkHref: "#glyph-25-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 513.0473,
    y: 219.198,
    xlinkHref: "#glyph-25-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 519.97607,
    y: 219.198,
    xlinkHref: "#glyph-25-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.90491,
    y: 219.198,
    xlinkHref: "#glyph-25-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.36926,
    y: 219.198,
    xlinkHref: "#glyph-25-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.29803,
    y: 219.198,
    xlinkHref: "#glyph-25-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 540.76245,
    y: 219.198,
    xlinkHref: "#glyph-25-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 544.22687,
    y: 219.198,
    xlinkHref: "#glyph-25-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.84106,
    y: 219.198,
    xlinkHref: "#glyph-25-9"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.973 60.012h105.71v-11.801h-105.71z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264.09 -151.33)",
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("use", {
    x: 315.758,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.7717,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 325.78537,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 330.79904,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 335.81274,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 340.82642,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.84009,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 350.85379,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.86746,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.88116,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 365.89484,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 370.90851,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 375.92221,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 380.93588,
    y: 219.101,
    xlinkHref: "#glyph-26-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.60599,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 417.24118,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.87634,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 428.51151,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 434.1467,
    y: 206.502,
    xlinkHref: "#glyph-27-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 436.96426,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 442.59946,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 448.23462,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 453.86978,
    y: 206.502,
    xlinkHref: "#glyph-27-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.68738,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 462.32254,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 467.9577,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 473.5929,
    y: 206.502,
    xlinkHref: "#glyph-27-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 476.41046,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 482.04565,
    y: 206.502,
    xlinkHref: "#glyph-27-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 492.1228,
    y: 205.81215,
    xlinkHref: "#glyph-28-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 497.1268,
    y: 205.81215,
    xlinkHref: "#glyph-28-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 502.1308,
    y: 205.81215,
    xlinkHref: "#glyph-28-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 507.1348,
    y: 205.81215,
    xlinkHref: "#glyph-28-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 509.63681,
    y: 205.81215,
    xlinkHref: "#glyph-28-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 517.13379,
    y: 205.81215,
    xlinkHref: "#glyph-28-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 211.57201,
    xlinkHref: "#glyph-29-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 206.04813,
    xlinkHref: "#glyph-29-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 200.21001,
    xlinkHref: "#glyph-29-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 194.07397,
    xlinkHref: "#glyph-29-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 184.81651,
    xlinkHref: "#glyph-29-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 178.67776,
    xlinkHref: "#glyph-29-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 172.23007,
    xlinkHref: "#glyph-29-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.04501,
    y: 165.47911,
    xlinkHref: "#glyph-29-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 214.45134,
    xlinkHref: "#glyph-29-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 208.61595,
    xlinkHref: "#glyph-29-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 202.78058,
    xlinkHref: "#glyph-29-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 197.31183,
    xlinkHref: "#glyph-29-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 191.47371,
    xlinkHref: "#glyph-29-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 185.33762,
    xlinkHref: "#glyph-29-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 179.4995,
    xlinkHref: "#glyph-29-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 175.80963,
    xlinkHref: "#glyph-29-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 169.97415,
    xlinkHref: "#glyph-29-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 166.28703,
    xlinkHref: "#glyph-29-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288.59265,
    y: 160.44891,
    xlinkHref: "#glyph-29-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.87903,
    y: 205.63,
    xlinkHref: "#glyph-28-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 535.883,
    y: 205.63,
    xlinkHref: "#glyph-28-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 540.88702,
    y: 205.63,
    xlinkHref: "#glyph-28-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.89099,
    y: 205.63,
    xlinkHref: "#glyph-28-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.39301,
    y: 205.63,
    xlinkHref: "#glyph-28-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.39697,
    y: 205.63,
    xlinkHref: "#glyph-28-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 555.89899,
    y: 205.63,
    xlinkHref: "#glyph-28-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.396,
    y: 205.63,
    xlinkHref: "#glyph-28-7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath2304);
export default __webpack_public_path__ + "static/media/path2304.38ec9b109d2850d48bd1175fa58c2354.svg";
export { ForwardRef as ReactComponent };